  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import Checkbox                                            from '@material-ui/core/Checkbox';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
  import InputLabel                                          from '@material-ui/core/InputLabel';
  import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
  import FormControl                                         from '@material-ui/core/FormControl';
  import Select                                              from '@material-ui/core/Select';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //--------------------
  // 3rd party libraries
  //--------------------
  import Cookies                                             from 'js-cookie';

  // import 'babel-polyfill'
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_CardsService }                                 from "../../_services";
  import { wu_GeolocationService }                           from "../../_services";
  import { wu_TransactionFlow }                              from "../../_services";
  //------
  // Style
  //------
  import TransferOnline2Style                                from "./TransferOnline2Style.jsx";
//-------
// images
//-------
//import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import WU_STEPS_estimate_active                            from "assets/img/wu/WU_STEPS_estimate_active.svg";
//import WU_STEPS_estimate_inactive                          from "assets/img/wu/WU_STEPS_estimate_inactive.svg";
  import WU_STEPS_progress_symbol_active                     from "assets/img/wu/WU_STEPS_progress_symbol_active.svg";
  import WU_STEPS_progress_symbol_inactive                   from "assets/img/wu/WU_STEPS_progress_symbol_inactive.svg";
  import WU_STEPS_recipient_active                           from "assets/img/wu/WU_STEPS_recipient_active.svg";
//import WU_STEPS_recipient_inactive                         from "assets/img/wu/WU_STEPS_recipient_inactive.svg";
//import WU_STEPS_review_active                              from "assets/img/wu/WU_STEPS_review_active.svg";
  import WU_STEPS_review_inactive                            from "assets/img/wu/WU_STEPS_review_inactive.svg";
  import WU_STEPS_sender_active                              from "assets/img/wu/WU_STEPS_sender_active.svg";
//import WU_STEPS_sender_inactive                            from "assets/img/wu/WU_STEPS_sender_inactive.svg";
  //----------
  // variables
  //----------
  const filename = "TransferOnline2 ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[Lockers]
  var TransferOnline2_continue_locked = true;

class TransferOnline2 extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    let viewSteps3_view_isHidden = false;
    let viewSteps4_view_isHidden = true;

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      dialogYN_msg                                         : "",
      dialogYN_isOpen                                      : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      viewSteps3_view_isHidden                             : viewSteps3_view_isHidden,
      viewSteps3_lbl_lbl1                                  : "",
      viewSteps3_lbl_lbl2                                  : "",
      viewSteps3_lbl_lbl3                                  : "",

      viewSteps4_view_isHidden                             : viewSteps4_view_isHidden,
      viewSteps4_lbl_lbl1                                  : "",
      viewSteps4_lbl_lbl2                                  : "",
      viewSteps4_lbl_lbl3                                  : "",
      viewSteps4_lbl_lbl4                                  : "",

      textField1                                           : "",
      textField1_hasError                                  : false,
      textField2                                           : "",
      textField2_hasError                                  : false,
      textField3                                           : "",
      textField3_hasError                                  : false,
      textField3_isHidden                                  : true,
      textField4                                           : "",
      textField4_hasError                                  : false,
      textField4_isHidden                                  : true,

      picker1_selIndex                                     : 0,  //reasonOfPayment
      picker1_textFieldLabel1_id                           : "",
      picker1_textFieldLabel1_text                         : "",
      picker1_isHidden                                     : false,
      picker1_hasError                                     : false,

      picker1b_selIndex                                    : 0,  //sourceOfFunds
      picker1b_textFieldLabel1_text                        : "",
      picker1b_textFieldLabel1_id                          : "",
      picker1b_isHidden                                    : true,
      picker1b_hasError                                    : false,

      picker1c_selIndex                                    : 0,  //relationshipWithReceiver
      picker1c_textFieldLabel1_text                        : "",
      picker1c_textFieldLabel1_id                          : "",
      picker1c_isHidden                                    : true,
      picker1c_hasError                                    : false,

      picker2_selIndex                                     : 0,  //isBehalfThirdParty
      picker2_textFieldLabel1_id                           : "",
      picker2_textFieldLabel1_text                         : "",
      picker2_isHidden                                     : false,
      picker2_hasError                                     : false,

      textField5                                           : "",
      textField5_hasError                                  : false,
      textField5_isHidden                                  : true,

      userCheckedTick                                      : false,

      view_D2BInfoText_isHidden                            : true,

      view_questCheckbox_isHidden                          : true,

      parserObject_getPaymentReasons                       : [],
      parserObject_getSourceOfFunds                        : [],
      parserObject_getRelationshipWithReceiver             : [],
      parserObject_getBehalfThirdParty                     : [],

      textField10_text                                     : "",
      textField11_text                                     : "",
      textField12_text                                     : "",
      textField13_text                                     : "",
      textField14_text                                     : "",
      textField15_text                                     : "",
      textField16_text                                     : "",
      textField17_text                                     : "",
      textField18_text                                     : "",
      textField19_text                                     : "",
      textField20_text                                     : "",
      textField21_text                                     : "",
      textField10_plh                                      : "",
      textField11_plh                                      : "",
      textField12_plh                                      : "",
      textField13_plh                                      : "",
      textField14_plh                                      : "",
      textField15_plh                                      : "",
      textField16_plh                                      : "",
      textField17_plh                                      : "",
      textField18_plh                                      : "",
      textField19_plh                                      : "",
      textField20_plh                                      : "",
      textField21_plh                                      : "",
      textField10_isHidden                                 : true,
      textField11_isHidden                                 : true,
      textField12_isHidden                                 : true,
      textField13_isHidden                                 : true,
      textField14_isHidden                                 : true,
      textField15_isHidden                                 : true,
      textField16_isHidden                                 : true,
      textField17_isHidden                                 : true,
      textField18_isHidden                                 : true,
      textField19_isHidden                                 : true,
      textField20_isHidden                                 : true,
      textField21_isHidden                                 : true,
      textField10_maxLength                                : 200,
      textField11_maxLength                                : 200,
      textField12_maxLength                                : 200,
      textField13_maxLength                                : 200,
      textField14_maxLength                                : 200,
      textField15_maxLength                                : 200,
      textField16_maxLength                                : 200,
      textField17_maxLength                                : 200,
      textField18_maxLength                                : 200,
      textField19_maxLength                                : 200,
      textField20_maxLength                                : 200,
      textField21_maxLength                                : 200,
      textField22_maxLength                                : 200,
      textField10_type                                     : "text",
      textField11_type                                     : "text",
      textField12_type                                     : "text",
      textField13_type                                     : "text",
      textField14_type                                     : "text",
      textField15_type                                     : "text",
      textField16_type                                     : "text",
      textField17_type                                     : "text",
      textField18_type                                     : "text",
      textField19_type                                     : "text",
      textField20_type                                     : "text",
      textField21_type                                     : "text",
      textField10_hasError                                 : false,
      textField11_hasError                                 : false,
      textField12_hasError                                 : false,
      textField13_hasError                                 : false,
      textField14_hasError                                 : false,
      textField15_hasError                                 : false,
      textField16_hasError                                 : false,
      textField17_hasError                                 : false,
      textField18_hasError                                 : false,
      textField19_hasError                                 : false,
      textField20_hasError                                 : false,
      textField21_hasError                                 : false,

      picker10_isHidden                                    : true,
      picker11_isHidden                                    : true,
      picker12_isHidden                                    : true,
      picker13_isHidden                                    : true,
      picker14_isHidden                                    : true,
      picker15_isHidden                                    : true,
      picker16_isHidden                                    : true,
      picker17_isHidden                                    : true,
      picker18_isHidden                                    : true,
      picker19_isHidden                                    : true,
      picker20_isHidden                                    : true,
      picker21_isHidden                                    : true,
      picker10_textFieldLabel1_text                        : "",
      picker11_textFieldLabel1_text                        : "",
      picker12_textFieldLabel1_text                        : "",
      picker13_textFieldLabel1_text                        : "",
      picker14_textFieldLabel1_text                        : "",
      picker15_textFieldLabel1_text                        : "",
      picker16_textFieldLabel1_text                        : "",
      picker17_textFieldLabel1_text                        : "",
      picker18_textFieldLabel1_text                        : "",
      picker19_textFieldLabel1_text                        : "",
      picker20_textFieldLabel1_text                        : "",
      picker21_textFieldLabel1_text                        : "",
      picker10_textFieldLabel1_id                          : "",
      picker11_textFieldLabel1_id                          : "",
      picker12_textFieldLabel1_id                          : "",
      picker13_textFieldLabel1_id                          : "",
      picker14_textFieldLabel1_id                          : "",
      picker15_textFieldLabel1_id                          : "",
      picker16_textFieldLabel1_id                          : "",
      picker17_textFieldLabel1_id                          : "",
      picker18_textFieldLabel1_id                          : "",
      picker19_textFieldLabel1_id                          : "",
      picker20_textFieldLabel1_id                          : "",
      picker21_textFieldLabel1_id                          : "",
      picker10_selIndex                                    : 0,
      picker11_selIndex                                    : 0,
      picker12_selIndex                                    : 0,
      picker13_selIndex                                    : 0,
      picker14_selIndex                                    : 0,
      picker15_selIndex                                    : 0,
      picker16_selIndex                                    : 0,
      picker17_selIndex                                    : 0,
      picker18_selIndex                                    : 0,
      picker19_selIndex                                    : 0,
      picker20_selIndex                                    : 0,
      picker21_selIndex                                    : 0,

      //filtering D2B
      listType_enabled                                     : true,
      level1_tIndex_value                                  : "",
      level2_tIndex_value                                  : "",
      level3_tIndex_value                                  : "",
      level4_tIndex_value                                  : "",
      level5_tIndex_value                                  : "",

      parserObject_picker10_d2bObj                         : [],
      parserObject_picker11_d2bObj                         : [],
      parserObject_picker12_d2bObj                         : [],
      parserObject_picker13_d2bObj                         : [],
      parserObject_picker14_d2bObj                         : [],
      parserObject_picker15_d2bObj                         : [],
      parserObject_picker16_d2bObj                         : [],
      parserObject_picker17_d2bObj                         : [],
      parserObject_picker18_d2bObj                         : [],
      parserObject_picker19_d2bObj                         : [],
      parserObject_picker20_d2bObj                         : [],
      parserObject_picker21_d2bObj                         : [],
      parserObject_picker10_d2bObj4picker                  : [],
      parserObject_picker11_d2bObj4picker                  : [],
      parserObject_picker12_d2bObj4picker                  : [],
      parserObject_picker13_d2bObj4picker                  : [],
      parserObject_picker14_d2bObj4picker                  : [],
      parserObject_picker15_d2bObj4picker                  : [],
      parserObject_picker16_d2bObj4picker                  : [],
      parserObject_picker17_d2bObj4picker                  : [],
      parserObject_picker18_d2bObj4picker                  : [],
      parserObject_picker19_d2bObj4picker                  : [],
      parserObject_picker20_d2bObj4picker                  : [],
      parserObject_picker21_d2bObj4picker                  : [],
      picker10_InputLabel                                  : "",
      picker11_InputLabel                                  : "",
      picker12_InputLabel                                  : "",
      picker13_InputLabel                                  : "",
      picker14_InputLabel                                  : "",
      picker15_InputLabel                                  : "",
      picker16_InputLabel                                  : "",
      picker17_InputLabel                                  : "",
      picker18_InputLabel                                  : "",
      picker19_InputLabel                                  : "",
      picker20_InputLabel                                  : "",
      picker21_InputLabel                                  : "",
      picker10_hasError                                    : false,
      picker11_hasError                                    : false,
      picker12_hasError                                    : false,
      picker13_hasError                                    : false,
      picker14_hasError                                    : false,
      picker15_hasError                                    : false,
      picker16_hasError                                    : false,
      picker17_hasError                                    : false,
      picker18_hasError                                    : false,
      picker19_hasError                                    : false,
      picker20_hasError                                    : false,
      picker21_hasError                                    : false,

      D2BInfoText_lbl1                                     : "",
      D2BInfoText_lbl2                                     : "",
      D2BInfoText_lbl3                                     : "",

      parserObject_getd2bfields                            : [],
      parserObject_getd2bfields_daysToDelivery             : "",
      parserObject_getd2bfields_cutOffTime                 : "",

      hideThisItemDEBBUG                                   : true,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    this.dialogYN_handleClose_Y                                       = this.dialogYN_handleClose_Y.bind(this);
    this.dialogYN_handleClose_N                                       = this.dialogYN_handleClose_N.bind(this);

    //[Lockers]
    this.isLockersActive                                              = this.isLockersActive.bind(this);
    this.startLockers                                                 = this.startLockers.bind(this);
    this.stopLockers                                                  = this.stopLockers.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                         = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                        = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                                       = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                                = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                               = this.Snackbar_textField_handleClose.bind(this);

    this.handleCustomDropDownClick_getPaymentReasons4Picker           = this.handleCustomDropDownClick_getPaymentReasons4Picker.bind(this);
    this.handleCustomDropDownClick_getSourceOfFunds4Picker            = this.handleCustomDropDownClick_getSourceOfFunds4Picker.bind(this);
    this.handleCustomDropDownClick_getRelationshipWithReceiver4Picker = this.handleCustomDropDownClick_getRelationshipWithReceiver4Picker.bind(this);
    this.handleCustomDropDownClick_getHandleBehalfThirdParty4Picker   = this.handleCustomDropDownClick_getHandleBehalfThirdParty4Picker.bind(this);
    this.handleCheckBoxClick_payWithoutDocs                           = this.handleCheckBoxClick_payWithoutDocs.bind(this);

    this.hideCheckBox_checked                                         = this.hideCheckBox_checked.bind(this);
    this.showCheckBox_checked                                         = this.showCheckBox_checked.bind(this);
    this.showSecurityQuestions                                        = this.showSecurityQuestions.bind(this);
    this.hideSecurityQuestions                                        = this.hideSecurityQuestions.bind(this);


    this.reset_child_dropDown                                         = this.reset_child_dropDown.bind(this);
    this.handleCustomDropDownClick_picker10                           = this.handleCustomDropDownClick_picker10.bind(this);
    this.handleCustomDropDownClick_picker11                           = this.handleCustomDropDownClick_picker11.bind(this);
    this.handleCustomDropDownClick_picker12                           = this.handleCustomDropDownClick_picker12.bind(this);
    this.handleCustomDropDownClick_picker13                           = this.handleCustomDropDownClick_picker13.bind(this);
    this.handleCustomDropDownClick_picker14                           = this.handleCustomDropDownClick_picker14.bind(this);
    this.handleCustomDropDownClick_picker15                           = this.handleCustomDropDownClick_picker15.bind(this);
    this.handleCustomDropDownClick_picker16                           = this.handleCustomDropDownClick_picker16.bind(this);
    this.handleCustomDropDownClick_picker17                           = this.handleCustomDropDownClick_picker17.bind(this);
    this.handleCustomDropDownClick_picker18                           = this.handleCustomDropDownClick_picker18.bind(this);
    this.handleCustomDropDownClick_picker19                           = this.handleCustomDropDownClick_picker19.bind(this);
    this.handleCustomDropDownClick_picker20                           = this.handleCustomDropDownClick_picker20.bind(this);
    this.handleCustomDropDownClick_picker21                           = this.handleCustomDropDownClick_picker21.bind(this);

    this.fieldNN_hide                                                 = this.fieldNN_hide.bind(this);
    this.fieldNN_show                                                 = this.fieldNN_show.bind(this);
    this.comboNN_refresh                                              = this.comboNN_refresh.bind(this);
    this.get_child_combo_index                                        = this.get_child_combo_index.bind(this);
    this.comboNN_fillData                                             = this.comboNN_fillData.bind(this);
    this.prefil_combo                                                 = this.prefil_combo.bind(this);
    this.get_combo_index                                              = this.get_combo_index.bind(this);
    this.get_combo_id                                                 = this.get_combo_id.bind(this);
    this.get_combo_value                                              = this.get_combo_value.bind(this);
    this.get_combo_tIndex                                             = this.get_combo_tIndex.bind(this);
    this.get_combo_comboValues_based_on_tIndex                        = this.get_combo_comboValues_based_on_tIndex.bind(this);
    this.fillD2bField                                                 = this.fillD2bField.bind(this);

    this.buildUI                                                      = this.buildUI.bind(this);
    this.geolocationPro                                               = this.geolocationPro.bind(this);

    this.btn_next_act                                                 = this.btn_next_act.bind(this);
    this.btn_next_act_isDisabled                                      = this.btn_next_act_isDisabled.bind(this);
    this.makeHTTPConn_next_normal                                     = this.makeHTTPConn_next_normal.bind(this);
    this.makeHTTPConn_next_d2b                                        = this.makeHTTPConn_next_d2b.bind(this);
    this.makeHTTPConn_next_step1                                      = this.makeHTTPConn_next_step1.bind(this);

    this.get_D2BField_xml_value                                       = this.get_D2BField_xml_value.bind(this);
    this.get_D2BField_json_value                                      = this.get_D2BField_json_value.bind(this);
    this.get_fieldCode_pickerIndex                                    = this.get_fieldCode_pickerIndex.bind(this);

    this.IE11_not_loading_state_workaround                            = this.IE11_not_loading_state_workaround.bind(this);
    this.isWebAppIOS12x                                               = this.isWebAppIOS12x.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    //[Lockers]
    this.stopLockers();

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="TransferOnline3" || localStorage.getItem("prev_view").trim()==="TransferOnlineCards"){
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}
      setTimeout(function() {
        this.IE11_not_loading_state_workaround();
      }.bind(this), 200);
      return;
    }

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      //++++++++++++
      //Login Screen
      //++++++++++++
      wu_Utilities.LogoutUserFromApp(filename);
      history.push(wu_Utilities.getNavigationURLs("LoginPage"));
      return;
    }
    //---------------------
    //newCustomer filtering--load Contoller---Exclude(LIGHT,BP)
    //---------------------
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
      if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
    }
    //--------------------
    //wu_getPaymentReasons---STATIC
    //--------------------
    let res_obj_wu_getPaymentReasons = wu_StaticDataService.wu_getPaymentReasons({});
    res_obj_wu_getPaymentReasons.reasons.sort(function(a, b) {
      if( a.order <= b.order){ return -1; }
      if( a.order >= b.order){ return 1; }
      return 0;
    });
    this.setState({
      "parserObject_getPaymentReasons"           : res_obj_wu_getPaymentReasons.reasons,
      "picker1_selIndex"                         : 0,
      "picker1_textFieldLabel1_text"             : "",
      "picker1_textFieldLabel1_id"               : "",
      "picker1_hasError"                         : false,
    });
    //-------------------
    //wu_getSourceOfFunds---STATIC
    //-------------------
    let res_obj_getSourceOfFunds = wu_StaticDataService.wu_getSourceOfFunds({});
    this.setState({
      "parserObject_getSourceOfFunds"            : res_obj_getSourceOfFunds.source,
      "picker1b_selIndex"                        : 0,
      "picker1b_textFieldLabel1_text"            : "",
      "picker1b_textFieldLabel1_id"              : "",
      "picker1b_hasError"                        : false,
    });
    //------------------------------
    //wu_getRelationshipWithReceiver---STATIC
    //------------------------------
    let res_obj_getRelationshipWithReceiver = wu_StaticDataService.wu_getRelationshipWithReceiver({});
    this.setState({
      "parserObject_getRelationshipWithReceiver" : res_obj_getRelationshipWithReceiver.relationships,
      "picker1c_selIndex"                        : 0,
      "picker1c_textFieldLabel1_text"            : "",
      "picker1c_textFieldLabel1_id"              : "",
      "picker1c_hasError"                        : false,
    });
    //----------------------
    //wu_getBehalfThirdParty---STATIC
    //----------------------
    let res_obj_wu_getBehalfThirdParty = wu_StaticDataService.wu_getBehalfThirdParty({});
    this.setState({
      "parserObject_getBehalfThirdParty"         : res_obj_wu_getBehalfThirdParty.behalf_third_party,
      "picker2_selIndex"                         : 0,
      "picker2_textFieldLabel1_text"             : "",
      "picker2_textFieldLabel1_id"               : "",
      "picker2_hasError"                         : false,
    });

    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
      let TransferOnline1_selCountry = JSON.parse(localStorage.getItem("TransferOnline1_selCountry"));
      var parserObject_getd2bfields_req_temp = {}
      parserObject_getd2bfields_req_temp["country"] = TransferOnline1_selCountry["ctry_wu_id"];
      parserObject_getd2bfields_req_temp["transId"] = "";
      //repeat transaction
      let parserObject_transhistorydetail_unique = null;
      try{ parserObject_transhistorydetail_unique = JSON.parse(localStorage.getItem("parserObject_transhistorydetail_unique")); } catch(err){;}
      if(parserObject_transhistorydetail_unique!==null){
          parserObject_getd2bfields_req_temp["transId"] = parserObject_transhistorydetail_unique.trans_id;
      }
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      //---------------
      //wu_getd2bfields
      //---------------
      wu_TransactionFlow
      .wu_getd2bfields(parserObject_getd2bfields_req_temp)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="TransferOnline2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.stopLockers();this.stopSpinners();//this.dialog200_handleClose();//stop DialogSpinner = NO
        if(api.print_logs){console.log(methName+"res.daysToDelivery="+res.daysToDelivery);}
        if(api.print_logs){console.log(methName+"res.cutOffTime    ="+res.cutOffTime);}
        if(res.d2BFields){
          for(var i=0; i<res.d2BFields.length; ++i){
            if(res.d2BFields[i]["fieldType"]==="COMBO" || res.d2BFields[i]["fieldType"]==="COMBO2"){
              let comboValues_obj = res.d2BFields[i]["comboValues"];
              comboValues_obj = comboValues_obj.sort(function(obj1, obj2) {
                return obj1.fieldValue.localeCompare(obj2.fieldValue);
              });
              res.d2BFields[i]["comboValues"] = comboValues_obj;
            }
          }
        }
        this.setState({
          "parserObject_getd2bfields"                : res.d2BFields,
          "parserObject_getd2bfields_daysToDelivery" : res.daysToDelivery,
          "parserObject_getd2bfields_cutOffTime"     : res.cutOffTime,
        });
        //------------------
        //wu_checkuploadedID
        //------------------
        wu_TransactionFlow
        .wu_checkuploadedID({"idnum":"", "idtype":"", "idctry":"", "firstName":"", "lastName":"", "snd_curr":"EUR", "principal":"10.00"})//OK
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="TransferOnline2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
          localStorage.setItem("parserObject_checkuploadedID",JSON.stringify(res));
          this.geolocationPro();//this.buildUI();
        })
        .catch(err => {
          this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
          console.log(methName+"wu_checkuploadedID err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      })
      .catch(err => {
        this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }
    else{
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      //------------------
      //wu_checkuploadedID
      //------------------
      wu_TransactionFlow
      .wu_checkuploadedID({"idnum":"", "idtype":"", "idctry":"", "firstName":"", "lastName":"", "snd_curr":"EUR", "principal":"10.00"})//OK
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="TransferOnline2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        localStorage.setItem("parserObject_checkuploadedID",JSON.stringify(res));
        this.geolocationPro();//this.buildUI();
      })
      .catch(err => {
        this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        console.log(methName+"wu_checkuploadedID err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    var daysToDelivery = this.state.parserObject_getd2bfields_daysToDelivery;
    var cutOffTime     = this.state.parserObject_getd2bfields_cutOffTime;
    var view_D2BInfoText_isHidden = true;
    var D2BInfoText_lbl1 = "";
    var D2BInfoText_lbl2 = "";
    var D2BInfoText_lbl3 = "";
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
      if(localStorage.getItem("lang")==="en"){
          view_D2BInfoText_isHidden = false;
          D2BInfoText_lbl1          = "";//"For Bank Account delivery:";
          D2BInfoText_lbl2          = "- The recipient will receive the money in "+daysToDelivery+" working day/s, If transaction is completed before: "+cutOffTime;
          D2BInfoText_lbl3          = "- If the account is not in the destination’s country local currency, there will be additional charges due to the exchange rate.";
      }
      else{
          view_D2BInfoText_isHidden = false;
          D2BInfoText_lbl1          = "";//"Για την παραλαβή χρημάτων σε Τραπεζικό Λογαριασμό:";
          D2BInfoText_lbl2          = "- Ο παραλήπτης θα λάβει τα χρήματα σε "+daysToDelivery+" εργάσιμη/ες ημέρα/ες, αν η συναλλαγή γίνει πριν τις: "+cutOffTime;
          D2BInfoText_lbl3          = "- Αν ο λογαριασμός δεν είναι στο τοπικό νόμισμα της χώρας παραλαβής, θα υπάρξουν επιπλέον χρεώσεις λόγω συναλλαγματικής ισοτιμίας.";
      }
    }

    return (
      <div className={classes.container}>
      <div id="refreshHelper"> </div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>
            {/* ------------------------- */}
            {/* ----------[STEPS3]------- */}
            {/* ------------------------- */}
            {this.state.viewSteps3_view_isHidden === true ? ( "" ) : (
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={3} sm={3} md={2}>
                    <div className={classes.viewSteps3Image}><img src={WU_STEPS_estimate_active} alt=""/></div>
                    <div className={classes.viewSteps3Label}>{this.NSInforString("TransferOnline123_viewSteps3_lbl_lbl1")}</div>
                  </GridItem>
                  <GridItem xs={1} sm={1} md={3}>
                    <div className={classes.viewSteps3Label}>&nbsp;</div>
                    <div className={classes.viewSteps3Image}><img src={WU_STEPS_progress_symbol_active} alt=""/></div>
                  </GridItem>
                  <GridItem xs={3} sm={3} md={2}>
                    <div className={classes.viewSteps3Image}><img src={WU_STEPS_recipient_active} alt=""/></div>
                    <div className={classes.viewSteps3Label}>{this.NSInforString("TransferOnline123_viewSteps3_lbl_lbl2")}</div>
                  </GridItem>
                  <GridItem xs={1} sm={1} md={3}>
                    <div className={classes.viewSteps3Label}>&nbsp;</div>
                    <div className={classes.viewSteps3Image}><img src={WU_STEPS_progress_symbol_inactive} alt=""/></div>
                  </GridItem>
                  <GridItem xs={3} sm={3} md={2}>
                    <div className={classes.viewSteps3Image}><img src={WU_STEPS_review_inactive} alt=""/></div>
                    <div className={classes.viewSteps3Label}>{this.NSInforString("TransferOnline123_viewSteps3_lbl_lbl3")}</div>
                  </GridItem>
                </GridContainer>
              </div>
            )}
            {/* ------------------------- */}
            {/* ----------[STEPS4]------- */}
            {/* ------------------------- */}
            {this.state.viewSteps4_view_isHidden === true ? ( "" ) : (
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={2} sm={2} md={2}>
                    <div className={classes.viewSteps4Image}><img src={WU_STEPS_estimate_active} alt=""/></div>
                    <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl1")}</div>
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <div className={classes.viewSteps4Label}>&nbsp;</div>
                    <div className={classes.viewSteps4ImageDots}><img src={WU_STEPS_progress_symbol_active} alt=""/></div>
                  </GridItem>
                  <GridItem xs={2} sm={2} md={2}>
                    <div className={classes.viewSteps4Image}><img src={WU_STEPS_sender_active} alt=""/></div>
                    <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl2")}</div>
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <div className={classes.viewSteps4Label}>&nbsp;</div>
                    <div className={classes.viewSteps4ImageDots}><img src={WU_STEPS_progress_symbol_active} alt=""/></div>
                  </GridItem>
                  <GridItem xs={2} sm={2} md={2}>
                    <div className={classes.viewSteps4Image}><img src={WU_STEPS_recipient_active} alt=""/></div>
                    <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl3")}</div>
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <div className={classes.viewSteps4Label}>&nbsp;</div>
                    <div className={classes.viewSteps4ImageDots}><img src={WU_STEPS_progress_symbol_inactive} alt=""/></div>
                  </GridItem>
                  <GridItem xs={2} sm={2} md={2}>
                    <div className={classes.viewSteps4Image}><img src={WU_STEPS_review_inactive} alt=""/></div>
                    <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl4")}</div>
                  </GridItem>
                </GridContainer>
              </div>
            )}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.TransferOnline2_viewStepsInfo_lbl_lbl1}>{this.NSInforString("TransferOnline2_viewStepsInfo_lbl_lbl1")}</div>
              </GridItem>
            </GridContainer>

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.TransferOnline2_viewStepsInfo_lbl_lbl2}>{this.NSInforString("TransferOnline2_viewStepsInfo_lbl_lbl2")}</div>
              </GridItem>
            </GridContainer>
            {/* ------------------------------------------------- */}
            {/* ----------FirstName------------------------------ */}
            {/* ------------------------------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField1_hasError}
                  className={classes.textField1}
                  id="textField1"
                  label={this.NSInforString("TransferOnline2_plh1")}
                  value={this.state.textField1}
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "textField1"),
                    type: "text"
                  }}
                />
              </GridItem>
            </GridContainer>
            {/* ------------------------------------------------- */}
            {/* ----------LastName------------------------------- */}
            {/* ------------------------------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField2_hasError}
                  className={classes.textField2}
                  id="textField2"
                  label={this.NSInforString("TransferOnline2_plh2")}
                  value={this.state.textField2}
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "textField2"),
                    type: "text"
                  }}
                />
              </GridItem>
            </GridContainer>
            {/* ------------------------------------------------- */}
            {/* ----------PurposeofTransaction------------------- */}
            {/* ------------------------------------------------- */}
            {this.state.picker1_isHidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker1_hasError} className={classes.picker1_textFieldLabel1}>
                    <InputLabel id="picker1_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline2_pic1")}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker1_textFieldLabel1"
                      value={this.state.picker1_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_getPaymentReasons4Picker(event)}
                    >
                      {this.state.parserObject_getPaymentReasons.map(function (aVal) {
                        if(localStorage.getItem("lang")==="en") { return <MenuItem key={aVal["descr_en"]} value={aVal["descr_en"]}>{aVal["descr_en"]}</MenuItem>; }
                        else                                    { return <MenuItem key={aVal["descr_en"]} value={aVal["descr_el"]}>{aVal["descr_el"]}</MenuItem>; }
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
            )}
            {/* ------------------------------------------------- */}
            {/* ----------sourceofFUnds-------------------------- */}
            {/* ------------------------------------------------- */}
            {this.state.picker1b_isHidden === true ? ( "" ) : (
              <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl fullWidth error={this.state.picker1b_hasError} className={classes.picker1b_textFieldLabel1}>
                      <InputLabel id="picker1b_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline2_pic1b")}</InputLabel>
                      <Select
                        displayEmpty
                        id="picker1b_textFieldLabel1"
                        value={this.state.picker1b_textFieldLabel1_text}
                        onChange={event => this.handleCustomDropDownClick_getSourceOfFunds4Picker(event)}
                      >
                        {this.state.parserObject_getSourceOfFunds.map(function (aVal) {
                          if(localStorage.getItem("lang")==="en") { return <MenuItem key={aVal["descr_en"]} value={aVal["descr_en"]}>{aVal["descr_en"]}</MenuItem>; }
                          else                                    { return <MenuItem key={aVal["descr_en"]} value={aVal["descr_el"]}>{aVal["descr_el"]}</MenuItem>; }
                        })}
                      </Select>
                    </FormControl>
                  </GridItem>
              </GridContainer>
            )}
            {/* ------------------------------------------------- */}
            {/* ----------RelationWithReceiver------------------- */}
            {/* ------------------------------------------------- */}
            {this.state.picker1c_isHidden === true ? ( "" ) : (
              <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl fullWidth error={this.state.picker1c_hasError} className={classes.picker1c_textFieldLabel1}>
                      <InputLabel id="picker1c_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline2_pic1c")}</InputLabel>
                      <Select
                        displayEmpty
                        id="picker1c_textFieldLabel1"
                        value={this.state.picker1c_textFieldLabel1_text}
                        onChange={event => this.handleCustomDropDownClick_getRelationshipWithReceiver4Picker(event)}
                      >
                        {this.state.parserObject_getRelationshipWithReceiver.map(function (aVal) {
                          if(localStorage.getItem("lang")==="en") { return <MenuItem key={aVal["descr_en"]} value={aVal["descr_en"]}>{aVal["descr_en"]}</MenuItem>; }
                          else                                    { return <MenuItem key={aVal["descr_en"]} value={aVal["descr_el"]}>{aVal["descr_el"]}</MenuItem>; }
                        })}
                      </Select>
                    </FormControl>
                  </GridItem>
              </GridContainer>
            )}
            {/* ------------------------------------------------- */}
            {/* ----------behalfThirdParty----------------------- */}
            {/* ------------------------------------------------- */}
            {this.state.picker2_isHidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker2_hasError} className={classes.picker2_textFieldLabel1}>
                    <InputLabel style={{marginTop:"-10px"}} id="picker2_textFieldLabel1_InputLabel">{this.NSInforString("TransferOnline2_pic2")}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker2_textFieldLabel1"
                      value={this.state.picker2_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_getHandleBehalfThirdParty4Picker(event)}
                    >
                      {this.state.parserObject_getBehalfThirdParty.map(function (aVal) {
                        if(localStorage.getItem("lang")==="en") { return <MenuItem key={aVal["descr_en"]} value={aVal["descr_en"]}>{aVal["descr_en"]}</MenuItem>; }
                        else                                    { return <MenuItem key={aVal["descr_en"]} value={aVal["descr_el"]}>{aVal["descr_el"]}</MenuItem>; }
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
            )}
            {/* ------------------------------------------------- */}
            {/* ----------VAT------------------------------------ */}
            {/* ------------------------------------------------- */}
            {this.state.textField5_isHidden === true ? ( "" ) : (
              <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      error={this.state.textField5_hasError}
                      className={classes.textField5}
                      id="textField5"
                      label={this.NSInforString("TransferOnline2_plh5")}
                      value={this.state.textField5}
                      InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField5"), type: "text" }}
                    />
                  </GridItem>
              </GridContainer>
            )}
            {/* ------------------------------------------------- */}
            {/* ----------questCheckbox-------------------------- */}
            {/* ------------------------------------------------- */}
            {this.state.view_questCheckbox_isHidden === true ? ( "" ) : (
              <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={this.handleCheckBoxClick_payWithoutDocs}
                          value="checkedA"
                          inputProps={{ 'aria-label': 'Checkbox A' }}
                        />
                      }
                      label={this.NSInforString("TransferOnline2_lbl_checkTick")}
                    />
                  </GridItem>
              </GridContainer>
            )}
            {/* ------------------------------------------------- */}
            {/* ----------Question------------------------------- */}
            {/* ------------------------------------------------- */}
            {this.state.textField3_isHidden === true ? ( "" ) : (
              <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      hidden
                      fullWidth
                      error={this.state.textField3_hasError}
                      className={classes.textField3}
                      id="textField3"
                      label={this.NSInforString("TransferOnline2_plh3")}
                      value={this.state.textField3}
                      InputProps={{
                        fullWidth: true,
                        onChange: event => this.change(event,"textField3"),
                        type: "text"
                      }}
                    />
                  </GridItem>
              </GridContainer>
            )}
            {/* ------------------------------------------------- */}
            {/* ----------Answer--------------------------------- */}
            {/* ------------------------------------------------- */}
            {this.state.textField4_isHidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField4_hasError}
                    className={classes.textField4}
                    id="textField4"
                    label={this.NSInforString("TransferOnline2_plh4")}
                    value={this.state.textField4}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "textField4"),
                      type: "text"
                    }}
                  />
                </GridItem>
              </GridContainer>
            )}
            {/* ------------------------------------------------- */}
            {/* ----------D2B TextField(1-10)-------------------- */}
            {/* ------------------------------------------------- */}
            <GridContainer justify="center">
              {this.state.textField10_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField10_hasError}
                    className={classes.textField10}
                    id="textField10"
                    label={this.state.textField10_plh}
                    value={this.state.textField10_text}
                    InputProps={{ onChange: event => this.change(event, "textField10_text"), type: this.state.textField10_type }}
                    inputProps={{maxLength: this.state.textField10_maxLength}}
                  />
                </GridItem>
              )}
              {this.state.textField11_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField11_hasError}
                    className={classes.textField11}
                    id="textField11"
                    label={this.state.textField11_plh}
                    value={this.state.textField11_text}
                    InputProps={{ onChange: event => this.change(event, "textField11_text"), type: this.state.textField11_type }}
                    inputProps={{maxLength: this.state.textField11_maxLength}}
                  />
                </GridItem>
              )}
              {this.state.textField12_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField12_hasError}
                    className={classes.textField12}
                    id="textField12"
                    label={this.state.textField12_plh}
                    value={this.state.textField12_text}
                    InputProps={{ onChange: event => this.change(event, "textField12_text"), type: this.state.textField12_type }}
                    inputProps={{maxLength: this.state.textField12_maxLength}}
                  />
                </GridItem>
              )}
              {this.state.textField13_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField13_hasError}
                    className={classes.textField13}
                    id="textField13"
                    label={this.state.textField13_plh}
                    value={this.state.textField13_text}
                    InputProps={{ onChange: event => this.change(event, "textField13_text"), type: this.state.textField13_type }}
                    inputProps={{maxLength: this.state.textField13_maxLength}}
                  />
                </GridItem>
              )}
              {this.state.textField14_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField14_hasError}
                    className={classes.textField14}
                    id="textField14"
                    label={this.state.textField14_plh}
                    value={this.state.textField14_text}
                    InputProps={{ onChange: event => this.change(event, "textField14_text"), type: this.state.textField14_type }}
                    inputProps={{maxLength: this.state.textField14_maxLength}}
                  />
                </GridItem>
              )}
              {this.state.textField15_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField15_hasError}
                    className={classes.textField15}
                    id="textField15"
                    label={this.state.textField15_plh}
                    value={this.state.textField15_text}
                    InputProps={{ onChange: event => this.change(event, "textField15_text"), type: this.state.textField15_type }}
                    inputProps={{maxLength: this.state.textField15_maxLength}}
                  />
                </GridItem>
              )}
              {this.state.textField16_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField16_hasError}
                    className={classes.textField16}
                    id="textField16"
                    label={this.state.textField16_plh}
                    value={this.state.textField16_text}
                    InputProps={{ onChange: event => this.change(event, "textField16_text"), type: this.state.textField16_type }}
                    inputProps={{maxLength: this.state.textField16_maxLength}}
                  />
                </GridItem>
              )}
              {this.state.textField17_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField17_hasError}
                    className={classes.textField17}
                    id="textField17"
                    label={this.state.textField17_plh}
                    value={this.state.textField17_text}
                    InputProps={{ onChange: event => this.change(event, "textField17_text"), type: this.state.textField17_type }}
                    inputProps={{maxLength: this.state.textField17_maxLength}}
                  />
                </GridItem>
              )}
              {this.state.textField18_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField18_hasError}
                    className={classes.textField18}
                    id="textField18"
                    label={this.state.textField18_plh}
                    value={this.state.textField18_text}
                    InputProps={{ onChange: event => this.change(event, "textField18_text"), type: this.state.textField18_type }}
                    inputProps={{maxLength: this.state.textField18_maxLength}}
                  />
                </GridItem>
              )}
              {this.state.textField19_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField19_hasError}
                    className={classes.textField19}
                    id="textField19"
                    label={this.state.textField19_plh}
                    value={this.state.textField19_text}
                    InputProps={{ onChange: event => this.change(event, "textField19_text"), type: this.state.textField19_type }}
                    inputProps={{maxLength: this.state.textField19_maxLength}}
                  />
                </GridItem>
              )}
              {this.state.textField20_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField20_hasError}
                    className={classes.textField20}
                    id="textField20"
                    label={this.state.textField20_plh}
                    value={this.state.textField20_text}
                    InputProps={{ onChange: event => this.change(event, "textField20_text"), type: this.state.textField20_type }}
                    inputProps={{maxLength: this.state.textField20_maxLength}}
                  />
                </GridItem>
              )}
              {this.state.textField21_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    error={this.state.textField21_hasError}
                    className={classes.textField21}
                    id="textField21"
                    label={this.state.textField21_plh}
                    value={this.state.textField21_text}
                    InputProps={{ onChange: event => this.change(event, "textField21_text"), type: this.state.textField21_type }}
                    inputProps={{maxLength: this.state.textField21_maxLength}}
                  />
                </GridItem>
              )}
              {/* ------------------------------------------------- */}
              {/* ----------D2B DropDown(1-10)--------------------- */}
              {/* ------------------------------------------------- */}
              {this.state.picker10_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker10_hasError} className={classes.picker10_textFieldLabel1}>
                    <InputLabel id="picker10_textFieldLabel1_InputLabel">{this.state.picker10_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker10_textFieldLabel1"
                      value={this.state.picker10_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker10(event)}
                    >
                      {this.state.parserObject_picker10_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker10"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {this.state.picker11_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker11_hasError} className={classes.picker11_textFieldLabel1}>
                    <InputLabel id="picker11_textFieldLabel1_InputLabel">{this.state.picker11_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker11_textFieldLabel1"
                      value={this.state.picker11_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker11(event)}
                    >
                      {this.state.parserObject_picker11_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker11"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {this.state.picker12_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker12_hasError} className={classes.picker12_textFieldLabel1}>
                    <InputLabel id="picker12_textFieldLabel1_InputLabel">{this.state.picker12_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker12_textFieldLabel1"
                      value={this.state.picker12_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker12(event)}
                    >
                      {this.state.parserObject_picker12_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker12"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {this.state.picker13_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker13_hasError} className={classes.picker13_textFieldLabel1}>
                    <InputLabel id="picker13_textFieldLabel1_InputLabel">{this.state.picker13_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker13_textFieldLabel1"
                      value={this.state.picker13_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker13(event)}
                    >
                      {this.state.parserObject_picker13_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker13"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {this.state.picker14_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker14_hasError} className={classes.picker14_textFieldLabel1}>
                    <InputLabel id="picker14_textFieldLabel1_InputLabel">{this.state.picker14_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker14_textFieldLabel1"
                      value={this.state.picker14_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker14(event)}
                    >
                      {this.state.parserObject_picker14_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker14"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {this.state.picker15_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker15_hasError} className={classes.picker15_textFieldLabel1}>
                    <InputLabel id="picker15_textFieldLabel1_InputLabel">{this.state.picker15_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker15_textFieldLabel1"
                      value={this.state.picker15_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker15(event)}
                    >
                      {this.state.parserObject_picker15_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker15"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {this.state.picker16_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker16_hasError} className={classes.picker16_textFieldLabel1}>
                    <InputLabel id="picker16_textFieldLabel1_InputLabel">{this.state.picker16_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker16_textFieldLabel1"
                      value={this.state.picker16_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker16(event)}
                    >
                      {this.state.parserObject_picker16_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker16"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {this.state.picker17_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker17_hasError} className={classes.picker17_textFieldLabel1}>
                    <InputLabel id="picker17_textFieldLabel1_InputLabel">{this.state.picker17_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker17_textFieldLabel1"
                      value={this.state.picker17_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker17(event)}
                    >
                      {this.state.parserObject_picker17_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker17"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {this.state.picker18_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker18_hasError} className={classes.picker18_textFieldLabel1}>
                    <InputLabel id="picker18_textFieldLabel1_InputLabel">{this.state.picker18_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker18_textFieldLabel1"
                      value={this.state.picker18_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker18(event)}
                    >
                      {this.state.parserObject_picker18_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker18"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {this.state.picker19_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker19_hasError} className={classes.picker19_textFieldLabel1}>
                    <InputLabel id="picker19_textFieldLabel1_InputLabel">{this.state.picker19_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker19_textFieldLabel1"
                      value={this.state.picker19_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker19(event)}
                    >
                      {this.state.parserObject_picker19_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker19"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {this.state.picker20_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker20_hasError} className={classes.picker20_textFieldLabel1}>
                    <InputLabel id="picker20_textFieldLabel1_InputLabel">{this.state.picker20_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker20_textFieldLabel1"
                      value={this.state.picker20_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker20(event)}
                    >
                      {this.state.parserObject_picker20_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker20"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {this.state.picker21_isHidden === true ? ( "" ) : (
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth error={this.state.picker21_hasError} className={classes.picker21_textFieldLabel1}>
                    <InputLabel id="picker21_textFieldLabel1_InputLabel">{this.state.picker21_InputLabel}</InputLabel>
                    <Select
                      displayEmpty
                      id="picker21_textFieldLabel1"
                      value={this.state.picker21_textFieldLabel1_text}
                      onChange={event => this.handleCustomDropDownClick_picker21(event)}
                    >
                      {this.state.parserObject_picker21_d2bObj4picker.map(function (akey) {
                        return <MenuItem key={"picker21"+akey} value={akey}>{akey}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </GridItem>
              )}
              {/* ------------------------------------------------- */}
              {/* ----------D2BInfoText---------------------------- */}
              {/* ------------------------------------------------- */}
              {view_D2BInfoText_isHidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.D2BInfoText_lbl1}>{D2BInfoText_lbl1}</div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.D2BInfoText_lbl2}>{D2BInfoText_lbl2}</div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.D2BInfoText_lbl3}>{D2BInfoText_lbl3}</div>
                  </GridItem>
                </GridContainer>
              )}
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------[Spinner Inline]------------------------ */}
            {/* -------------------------------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.textCenter}>
                  <CustomButton
                    disabled={this.btn_next_act_isDisabled()}
                    className={classes.yellowButton}
                    color="rose"
                    onClick={this.btn_next_act}
                    type="submit">
                    {this.NSInforString("TransferOnline2_btn_next")}
                  </CustomButton>
                </div>
              </GridItem>
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------[goBack Bottom]------------------------- */}
            {/* -------------------------------------------------- */}
            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("TransferOnline2_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div id="dialog">
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div id="dialog">
          <Dialog
            open={this.state.dialogYN_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialogYN_handleClose_N}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialogYN_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialogYN_handleClose_Y}>{this.NSInforString("alert_YES")}</Button>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialogYN_handleClose_N}>{this.NSInforString("alert_NO")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* -------------------------------------------------- */}
        {/* ----------[Spinner Dialog]------------------------ */}
        {/* -------------------------------------------------- */}
        <div id="spinnerDialog">
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  geolocationPro(){
    let methName = "geolocationPro ";
    //-------------------
    //wu_getPhonePrefixes---STATIC
    //-------------------
    let phonePrefixes = wu_StaticDataService.wu_getPhonePrefixes({});
    //--------------
    //wu_geolocation
    //--------------
    wu_GeolocationService
    .wu_geolocationPro({})
    .then(res => {
      localStorage.setItem("parserObject_geolocationPro",JSON.stringify(res));
      let ws_countryCode = "";
      try {ws_countryCode = res["countryCode"]; }catch(err){;} if(ws_countryCode === "undefined" || ws_countryCode === null || (typeof ws_countryCode ==="undefined")){ws_countryCode = "";}
      console.log(methName+"ws_countryCode="+ws_countryCode);
      this.setState({ "countryCode":ws_countryCode });
      this.buildUI();//this.buildUI();
    })
    .catch(err => {
      console.log(methName+"err="+err);
      this.setState({ "countryCode":"" });
      this.buildUI();//this.buildUI();
    });
  }
  //----------------------------------------------------------------------------------------------------
  buildUI(){
      let methName = filename+"buildUI ";
      if(api.print_logs){console.log(methName);}

      let d2bCnt = 0;
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          d2bCnt = this.state.parserObject_getd2bfields.length;

          let textField10_plh = ""; let picker10_textFieldLabel1_text = "";
          let textField11_plh = ""; let picker11_textFieldLabel1_text = "";
          let textField12_plh = ""; let picker12_textFieldLabel1_text = "";
          let textField13_plh = ""; let picker13_textFieldLabel1_text = "";
          let textField14_plh = ""; let picker14_textFieldLabel1_text = "";
          let textField15_plh = ""; let picker15_textFieldLabel1_text = "";
          let textField16_plh = ""; let picker16_textFieldLabel1_text = "";
          let textField17_plh = ""; let picker17_textFieldLabel1_text = "";
          let textField18_plh = ""; let picker18_textFieldLabel1_text = "";
          let textField19_plh = ""; let picker19_textFieldLabel1_text = "";
          let textField20_plh = ""; let picker20_textFieldLabel1_text = "";
          let textField21_plh = ""; let picker21_textFieldLabel1_text = "";
          if(api.print_logs){console.log("step1");}

          if(d2bCnt>0){ try{ textField10_plh = this.state.parserObject_getd2bfields[0]["fieldName"];  picker10_textFieldLabel1_text = this.state.parserObject_getd2bfields[0]["fieldName"];  }catch(err){ ; } }
          if(d2bCnt>1){ try{ textField11_plh = this.state.parserObject_getd2bfields[1]["fieldName"];  picker11_textFieldLabel1_text = this.state.parserObject_getd2bfields[1]["fieldName"];  }catch(err){ ; } }
          if(d2bCnt>2){ try{ textField12_plh = this.state.parserObject_getd2bfields[2]["fieldName"];  picker12_textFieldLabel1_text = this.state.parserObject_getd2bfields[2]["fieldName"];  }catch(err){ ; } }
          if(d2bCnt>3){ try{ textField13_plh = this.state.parserObject_getd2bfields[3]["fieldName"];  picker13_textFieldLabel1_text = this.state.parserObject_getd2bfields[3]["fieldName"];  }catch(err){ ; } }
          if(d2bCnt>4){ try{ textField14_plh = this.state.parserObject_getd2bfields[4]["fieldName"];  picker14_textFieldLabel1_text = this.state.parserObject_getd2bfields[4]["fieldName"];  }catch(err){ ; } }
          if(d2bCnt>5){ try{ textField15_plh = this.state.parserObject_getd2bfields[5]["fieldName"];  picker15_textFieldLabel1_text = this.state.parserObject_getd2bfields[5]["fieldName"];  }catch(err){ ; } }
          if(d2bCnt>6){ try{ textField16_plh = this.state.parserObject_getd2bfields[6]["fieldName"];  picker16_textFieldLabel1_text = this.state.parserObject_getd2bfields[6]["fieldName"];  }catch(err){ ; } }
          if(d2bCnt>7){ try{ textField17_plh = this.state.parserObject_getd2bfields[7]["fieldName"];  picker17_textFieldLabel1_text = this.state.parserObject_getd2bfields[7]["fieldName"];  }catch(err){ ; } }
          if(d2bCnt>8){ try{ textField18_plh = this.state.parserObject_getd2bfields[8]["fieldName"];  picker18_textFieldLabel1_text = this.state.parserObject_getd2bfields[8]["fieldName"];  }catch(err){ ; } }
          if(d2bCnt>9){ try{ textField19_plh = this.state.parserObject_getd2bfields[9]["fieldName"];  picker19_textFieldLabel1_text = this.state.parserObject_getd2bfields[9]["fieldName"];  }catch(err){ ; } }
          if(d2bCnt>9){ try{ textField20_plh = this.state.parserObject_getd2bfields[10]["fieldName"]; picker20_textFieldLabel1_text = this.state.parserObject_getd2bfields[10]["fieldName"]; }catch(err){ ; } }
          if(d2bCnt>9){ try{ textField21_plh = this.state.parserObject_getd2bfields[11]["fieldName"]; picker21_textFieldLabel1_text = this.state.parserObject_getd2bfields[11]["fieldName"]; }catch(err){ ; } }
          if(api.print_logs){console.log("step2a");}

          // let fieldLength_10 = 200; if(d2bCnt>0) { try{ fieldLength_10 = parseInt(this.state.parserObject_getd2bfields[0]["fieldLength"]);  }catch(err){ fieldLength_10 = 200; } }
          // let fieldLength_11 = 200; if(d2bCnt>1) { try{ fieldLength_11 = parseInt(this.state.parserObject_getd2bfields[1]["fieldLength"]);  }catch(err){ fieldLength_11 = 200; } }
          // let fieldLength_12 = 200; if(d2bCnt>2) { try{ fieldLength_12 = parseInt(this.state.parserObject_getd2bfields[2]["fieldLength"]);  }catch(err){ fieldLength_12 = 200; } }
          // let fieldLength_13 = 200; if(d2bCnt>3) { try{ fieldLength_13 = parseInt(this.state.parserObject_getd2bfields[3]["fieldLength"]);  }catch(err){ fieldLength_13 = 200; } }
          // let fieldLength_14 = 200; if(d2bCnt>4) { try{ fieldLength_14 = parseInt(this.state.parserObject_getd2bfields[4]["fieldLength"]);  }catch(err){ fieldLength_14 = 200; } }
          // let fieldLength_15 = 200; if(d2bCnt>5) { try{ fieldLength_15 = parseInt(this.state.parserObject_getd2bfields[5]["fieldLength"]);  }catch(err){ fieldLength_15 = 200; } }
          // let fieldLength_16 = 200; if(d2bCnt>6) { try{ fieldLength_16 = parseInt(this.state.parserObject_getd2bfields[6]["fieldLength"]);  }catch(err){ fieldLength_16 = 200; } }
          // let fieldLength_17 = 200; if(d2bCnt>7) { try{ fieldLength_17 = parseInt(this.state.parserObject_getd2bfields[7]["fieldLength"]);  }catch(err){ fieldLength_17 = 200; } }
          // let fieldLength_18 = 200; if(d2bCnt>8) { try{ fieldLength_18 = parseInt(this.state.parserObject_getd2bfields[8]["fieldLength"]);  }catch(err){ fieldLength_18 = 200; } }
          // let fieldLength_19 = 200; if(d2bCnt>9) { try{ fieldLength_19 = parseInt(this.state.parserObject_getd2bfields[9]["fieldLength"]);  }catch(err){ fieldLength_19 = 200; } }
          // let fieldLength_20 = 200; if(d2bCnt>10){ try{ fieldLength_20 = parseInt(this.state.parserObject_getd2bfields[10]["fieldLength"]); }catch(err){ fieldLength_20 = 200; } }
          // let fieldLength_21 = 200; if(d2bCnt>11){ try{ fieldLength_21 = parseInt(this.state.parserObject_getd2bfields[11]["fieldLength"]); }catch(err){ fieldLength_21 = 200; } }
          let fieldLength_10 = 200; if(d2bCnt>0) { try{ fieldLength_10 = parseInt(this.find_fieldLength_fromFieldName("buildUI 10",textField10_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_10 = 200; } }
          let fieldLength_11 = 200; if(d2bCnt>1) { try{ fieldLength_11 = parseInt(this.find_fieldLength_fromFieldName("buildUI 11",textField11_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_11 = 200; } }
          let fieldLength_12 = 200; if(d2bCnt>2) { try{ fieldLength_12 = parseInt(this.find_fieldLength_fromFieldName("buildUI 12",textField12_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_12 = 200; } }
          let fieldLength_13 = 200; if(d2bCnt>3) { try{ fieldLength_13 = parseInt(this.find_fieldLength_fromFieldName("buildUI 13",textField13_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_13 = 200; } }
          let fieldLength_14 = 200; if(d2bCnt>4) { try{ fieldLength_14 = parseInt(this.find_fieldLength_fromFieldName("buildUI 14",textField14_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_14 = 200; } }
          let fieldLength_15 = 200; if(d2bCnt>5) { try{ fieldLength_15 = parseInt(this.find_fieldLength_fromFieldName("buildUI 15",textField15_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_15 = 200; } }
          let fieldLength_16 = 200; if(d2bCnt>6) { try{ fieldLength_16 = parseInt(this.find_fieldLength_fromFieldName("buildUI 16",textField16_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_16 = 200; } }
          let fieldLength_17 = 200; if(d2bCnt>7) { try{ fieldLength_17 = parseInt(this.find_fieldLength_fromFieldName("buildUI 17",textField17_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_17 = 200; } }
          let fieldLength_18 = 200; if(d2bCnt>8) { try{ fieldLength_18 = parseInt(this.find_fieldLength_fromFieldName("buildUI 18",textField18_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_18 = 200; } }
          let fieldLength_19 = 200; if(d2bCnt>9) { try{ fieldLength_19 = parseInt(this.find_fieldLength_fromFieldName("buildUI 19",textField19_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_19 = 200; } }
          let fieldLength_20 = 200; if(d2bCnt>10){ try{ fieldLength_20 = parseInt(this.find_fieldLength_fromFieldName("buildUI 20",textField20_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_20 = 200; } }
          let fieldLength_21 = 200; if(d2bCnt>11){ try{ fieldLength_21 = parseInt(this.find_fieldLength_fromFieldName("buildUI 21",textField21_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_21 = 200; } }
          if(api.print_logs){console.log("step2b");}

          let required_10 = false; if(d2bCnt>0) { try{ required_10 = this.state.parserObject_getd2bfields[0]["required"];  }catch(err){ ; } }
          let required_11 = false; if(d2bCnt>1) { try{ required_11 = this.state.parserObject_getd2bfields[1]["required"];  }catch(err){ ; } }
          let required_12 = false; if(d2bCnt>2) { try{ required_12 = this.state.parserObject_getd2bfields[2]["required"];  }catch(err){ ; } }
          let required_13 = false; if(d2bCnt>3) { try{ required_13 = this.state.parserObject_getd2bfields[3]["required"];  }catch(err){ ; } }
          let required_14 = false; if(d2bCnt>4) { try{ required_14 = this.state.parserObject_getd2bfields[4]["required"];  }catch(err){ ; } }
          let required_15 = false; if(d2bCnt>5) { try{ required_15 = this.state.parserObject_getd2bfields[5]["required"];  }catch(err){ ; } }
          let required_16 = false; if(d2bCnt>6) { try{ required_16 = this.state.parserObject_getd2bfields[6]["required"];  }catch(err){ ; } }
          let required_17 = false; if(d2bCnt>7) { try{ required_17 = this.state.parserObject_getd2bfields[7]["required"];  }catch(err){ ; } }
          let required_18 = false; if(d2bCnt>8) { try{ required_18 = this.state.parserObject_getd2bfields[8]["required"];  }catch(err){ ; } }
          let required_19 = false; if(d2bCnt>9) { try{ required_19 = this.state.parserObject_getd2bfields[9]["required"];  }catch(err){ ; } }
          let required_20 = false; if(d2bCnt>10){ try{ required_20 = this.state.parserObject_getd2bfields[10]["required"]; }catch(err){ ; } }
          let required_21 = false; if(d2bCnt>11){ try{ required_21 = this.state.parserObject_getd2bfields[11]["required"]; }catch(err){ ; } }
          if(api.print_logs){console.log("step3");}

          let optionalStr = (localStorage.getItem("lang")==="en") ?  "(Optional)" : "(Προαιρετικό)";
          if(d2bCnt>0) { try{ textField10_plh = (required_10) ? textField10_plh : textField10_plh+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>1) { try{ textField11_plh = (required_11) ? textField11_plh : textField11_plh+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>2) { try{ textField12_plh = (required_12) ? textField12_plh : textField12_plh+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>3) { try{ textField13_plh = (required_13) ? textField13_plh : textField13_plh+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>4) { try{ textField14_plh = (required_14) ? textField14_plh : textField14_plh+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>5) { try{ textField15_plh = (required_15) ? textField15_plh : textField15_plh+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>6) { try{ textField16_plh = (required_16) ? textField16_plh : textField16_plh+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>7) { try{ textField17_plh = (required_17) ? textField17_plh : textField17_plh+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>8) { try{ textField18_plh = (required_18) ? textField18_plh : textField18_plh+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>9) { try{ textField19_plh = (required_19) ? textField19_plh : textField19_plh+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>10){ try{ textField20_plh = (required_20) ? textField20_plh : textField20_plh+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>11){ try{ textField21_plh = (required_21) ? textField21_plh : textField21_plh+" "+optionalStr; }catch(err){ ; } }
          if(api.print_logs){console.log("step4");}

          if(d2bCnt>0) { try{ picker10_textFieldLabel1_text = (required_10) ? picker10_textFieldLabel1_text : picker10_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>1) { try{ picker11_textFieldLabel1_text = (required_11) ? picker11_textFieldLabel1_text : picker11_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>2) { try{ picker12_textFieldLabel1_text = (required_12) ? picker12_textFieldLabel1_text : picker12_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>3) { try{ picker13_textFieldLabel1_text = (required_13) ? picker13_textFieldLabel1_text : picker13_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>4) { try{ picker14_textFieldLabel1_text = (required_14) ? picker14_textFieldLabel1_text : picker14_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>5) { try{ picker15_textFieldLabel1_text = (required_15) ? picker15_textFieldLabel1_text : picker15_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>6) { try{ picker16_textFieldLabel1_text = (required_16) ? picker16_textFieldLabel1_text : picker16_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>7) { try{ picker17_textFieldLabel1_text = (required_17) ? picker17_textFieldLabel1_text : picker17_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>8) { try{ picker18_textFieldLabel1_text = (required_18) ? picker18_textFieldLabel1_text : picker18_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>9) { try{ picker19_textFieldLabel1_text = (required_19) ? picker19_textFieldLabel1_text : picker19_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>10){ try{ picker20_textFieldLabel1_text = (required_20) ? picker20_textFieldLabel1_text : picker20_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(d2bCnt>11){ try{ picker21_textFieldLabel1_text = (required_21) ? picker21_textFieldLabel1_text : picker21_textFieldLabel1_text+" "+optionalStr; }catch(err){ ; } }
          if(api.print_logs){console.log("step5");}

          this.setState({
            "textField10_plh":textField10_plh, "picker10_textFieldLabel1_text":picker10_textFieldLabel1_text, "textField10_maxLength":fieldLength_10,
            "textField11_plh":textField11_plh, "picker11_textFieldLabel1_text":picker11_textFieldLabel1_text, "textField11_maxLength":fieldLength_11,
            "textField12_plh":textField12_plh, "picker12_textFieldLabel1_text":picker12_textFieldLabel1_text, "textField12_maxLength":fieldLength_12,
            "textField13_plh":textField13_plh, "picker13_textFieldLabel1_text":picker13_textFieldLabel1_text, "textField13_maxLength":fieldLength_13,
            "textField14_plh":textField14_plh, "picker14_textFieldLabel1_text":picker14_textFieldLabel1_text, "textField14_maxLength":fieldLength_14,
            "textField15_plh":textField15_plh, "picker15_textFieldLabel1_text":picker15_textFieldLabel1_text, "textField15_maxLength":fieldLength_15,
            "textField16_plh":textField16_plh, "picker16_textFieldLabel1_text":picker16_textFieldLabel1_text, "textField16_maxLength":fieldLength_16,
            "textField17_plh":textField17_plh, "picker17_textFieldLabel1_text":picker17_textFieldLabel1_text, "textField17_maxLength":fieldLength_17,
            "textField18_plh":textField18_plh, "picker18_textFieldLabel1_text":picker18_textFieldLabel1_text, "textField18_maxLength":fieldLength_18,
            "textField19_plh":textField19_plh, "picker19_textFieldLabel1_text":picker19_textFieldLabel1_text, "textField19_maxLength":fieldLength_19,
            "textField20_plh":textField20_plh, "picker20_textFieldLabel1_text":picker20_textFieldLabel1_text, "textField20_maxLength":fieldLength_20,
            "textField21_plh":textField21_plh, "picker21_textFieldLabel1_text":picker21_textFieldLabel1_text, "textField21_maxLength":fieldLength_21,
          });
          if(api.print_logs){console.log("step6");}

          if(api.print_logs){console.log("d2bCnt="+d2bCnt);}
          if(d2bCnt===0){
              //
              this.fieldNN_hide("10",0); this.fieldNN_hide("11",1); this.fieldNN_hide("12",2); this.fieldNN_hide("13",3); this.fieldNN_hide("14",4); this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7); this.fieldNN_hide("18",8); this.fieldNN_hide("19",9); this.fieldNN_hide("20",10); this.fieldNN_hide("21",11);
          }
          if(d2bCnt===1){
              this.fieldNN_show("10",0);
              this.fieldNN_hide("11",1); this.fieldNN_hide("12",2); this.fieldNN_hide("13",3); this.fieldNN_hide("14",4); this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7); this.fieldNN_hide("18",8); this.fieldNN_hide("19",9); this.fieldNN_hide("20",10); this.fieldNN_hide("21",11);
          }
          if(d2bCnt===2){
              this.fieldNN_show("10",0); this.fieldNN_show("11",1);
              this.fieldNN_hide("12",2); this.fieldNN_hide("13",3); this.fieldNN_hide("14",4); this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7); this.fieldNN_hide("18",8); this.fieldNN_hide("19",9); this.fieldNN_hide("20",10); this.fieldNN_hide("21",11);
          }
          if(d2bCnt===3){
              this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2);
              this.fieldNN_hide("13",3); this.fieldNN_hide("14",4); this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7); this.fieldNN_hide("18",8); this.fieldNN_hide("19",9); this.fieldNN_hide("20",10); this.fieldNN_hide("21",11);
          }
          if(d2bCnt===4){
              this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3);
              this.fieldNN_hide("14",4); this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7); this.fieldNN_hide("18",8); this.fieldNN_hide("19",9); this.fieldNN_hide("20",10); this.fieldNN_hide("21",11);
          }
          if(d2bCnt===5){
              this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4);
              this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7); this.fieldNN_hide("18",8); this.fieldNN_hide("19",9); this.fieldNN_hide("20",10); this.fieldNN_hide("21",11);
          }
          if(d2bCnt===6){
              this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4); this.fieldNN_show("15",5);
              this.fieldNN_hide("16",6); this.fieldNN_hide("17",7); this.fieldNN_hide("18",8); this.fieldNN_hide("19",9); this.fieldNN_hide("20",10); this.fieldNN_hide("21",11);
          }
          if(d2bCnt===7){
              this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4); this.fieldNN_show("15",5); this.fieldNN_show("16",6);
              this.fieldNN_hide("17",7); this.fieldNN_hide("18",8); this.fieldNN_hide("19",9); this.fieldNN_hide("20",10); this.fieldNN_hide("21",11);
          }
          if(d2bCnt===8){
              this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4); this.fieldNN_show("15",5); this.fieldNN_show("16",6); this.fieldNN_show("17",7);
              this.fieldNN_hide("18",8); this.fieldNN_hide("19",9); this.fieldNN_hide("20",10); this.fieldNN_hide("21",11);
          }
          if(d2bCnt===9){
              this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4); this.fieldNN_show("15",5); this.fieldNN_show("16",6); this.fieldNN_show("17",7); this.fieldNN_show("18",8);
              this.fieldNN_hide("19",9); this.fieldNN_hide("20",10); this.fieldNN_hide("21",11);
          }
          if(d2bCnt===10){
              this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4); this.fieldNN_show("15",5); this.fieldNN_show("16",6); this.fieldNN_show("17",7); this.fieldNN_show("18",8); this.fieldNN_show("19",9);
              this.fieldNN_hide("20",10); this.fieldNN_hide("21",11);
          }
          if(d2bCnt===11){
              this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4); this.fieldNN_show("15",5); this.fieldNN_show("16",6); this.fieldNN_show("17",7); this.fieldNN_show("18",8); this.fieldNN_show("19",9); this.fieldNN_show("20",10);
              this.fieldNN_hide("21",11);
          }
          if(d2bCnt===11){
              this.fieldNN_show("10",0); this.fieldNN_show("11",1); this.fieldNN_show("12",2); this.fieldNN_show("13",3); this.fieldNN_show("14",4); this.fieldNN_show("15",5); this.fieldNN_show("16",6); this.fieldNN_show("17",7); this.fieldNN_show("18",8); this.fieldNN_show("19",9); this.fieldNN_show("20",10); this.fieldNN_show("21",11);
              //
          }
          if(api.print_logs){console.log("step7");}

          let daysToDelivery = this.state.parserObject_getd2bfields_daysToDelivery;
          let cutOffTime     = this.state.parserObject_getd2bfields_cutOffTime;
          if(localStorage.getItem("lang")==="en"){
            this.setState({
              "view_D2BInfoText_isHidden" : false,
              "D2BInfoText_lbl1"          : "",//"For Bank Account delivery:",
              "D2BInfoText_lbl2"          : "- The recipient will receive the money in "+daysToDelivery+" working day/s, If transaction is completed before: "+cutOffTime,
            //"D2BInfoText_lbl3"          : "- If the account is not in local currency in the destination country, there will be additional charges due to the exchange rate",
              "D2BInfoText_lbl3"          : "- If the account is not in the destination’s country local currency, there will be additional charges due to the exchange rate."
            });
          }
          else{
            this.setState({
              "view_D2BInfoText_isHidden" : false,
              "D2BInfoText_lbl1"          : "",//"Για την παραλαβή χρημάτων σε Τραπεζικό Λογαριασμό:",
              "D2BInfoText_lbl2"          : "- Ο παραλήπτης θα λάβει τα χρήματα σε "+daysToDelivery+" εργάσιμη/ες ημέρα/ες, αν η συναλλαγή γίνει πριν τις: "+cutOffTime,
            //"D2BInfoText_lbl3"          : "- Αν ο λογαριασμός δεν είναι σε τοπικό νόμισμα στη χώρα παραλαβής, θα υπάρξουν επιπλέον χρεώσεις που θα οφείλονται στη συναλλαγματική ισοτιμία.",
              "D2BInfoText_lbl3"          : "- Αν ο λογαριασμός δεν είναι στο τοπικό νόμισμα της χώρας παραλαβής, θα υπάρξουν επιπλέον χρεώσεις λόγω συναλλαγματικής ισοτιμίας."
            });
          }
          if(api.print_logs){console.log("step8");}
      }
      else{
          //this.fieldNN_hide("10",0);; this.fieldNN_hide("11",1); this.fieldNN_hide("12",2); this.fieldNN_hide("13",3); this.fieldNN_hide("14",4); this.fieldNN_hide("15",5); this.fieldNN_hide("16",6); this.fieldNN_hide("17",7); this.fieldNN_hide("18",8); this.field19_hide];
          this.setState({
            "D2BInfoText_lbl1" : "",
            "D2BInfoText_lbl2" : "",
            "D2BInfoText_lbl3" : ""
          });
      }
      //---------------
      //Question/Answer
      //---------------
      let TransferOnline1_selCountry = JSON.parse(localStorage.getItem("TransferOnline1_selCountry"));
      let isMandQA = TransferOnline1_selCountry["isMandQA"];
      let isMandID = TransferOnline1_selCountry["isMandID"];
      if(isMandQA===false && isMandID===false){ if(api.print_logs){console.log("[SQ:SETUP] isMandQA===false && isMandID===false");} this.showCheckBox_checked(false); this.hideSecurityQuestions(); } //IRELAND
      if(isMandQA===false && isMandID===true) { if(api.print_logs){console.log("[SQ:SETUP] isMandQA===false && isMandID===true");}  this.hideCheckBox_checked(false); this.hideSecurityQuestions(); } //GREECE
      if(isMandQA===true  && isMandID===false){ if(api.print_logs){console.log("[SQ:SETUP] isMandQA===true  && isMandID===false");} this.showCheckBox_checked(false); this.showSecurityQuestions(); } //LIBERIA
      if(isMandQA===true  && isMandID===true) { if(api.print_logs){console.log("[SQ:SETUP] isMandQA===true  && isMandID===true");}  this.hideCheckBox_checked(false); this.showSecurityQuestions(); } //MADAGASCAR
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          this.hideCheckBox_checked(false); this.hideSecurityQuestions();
      }
      //------------------
      //repeat transaction
      //------------------
      let parserObject_transhistorydetail_unique = null;
      try{ parserObject_transhistorydetail_unique = JSON.parse(localStorage.getItem("parserObject_transhistorydetail_unique")); } catch(err){;}
      if(parserObject_transhistorydetail_unique!==null){
          this.setState({
            "textField1": parserObject_transhistorydetail_unique.rcv_fname,
            "textField2": parserObject_transhistorydetail_unique.rcv_lname,
          });
      }

      //------------------
      //validate uploadPDF---in order to protect user to fill in all the fields for nothing, inform him on page load
      //------------------
      let shouldUploadPDF = "false";
      let parserObject_checkuploadedID = JSON.parse(localStorage.getItem("parserObject_checkuploadedID"));
      try{ shouldUploadPDF = parserObject_checkuploadedID["returnText"]; } catch(err){;}
      if(shouldUploadPDF==="true"){
          //this.dialog_handleOpen(this.NSInforString("TransferOnline2_msg_shouldUploadPDF"));
          this.dialogYN_handleOpen(this.NSInforString("TransferOnline2_msg_shouldUploadPDF_with_nav"));
          return;
      }

      if(this.isWebAppIOS12x()){
        setTimeout(function() {
          let sel = document.getElementById('root');
          sel.style.display='none';
          sel.style.display='flex';
        }.bind(), 250);
      }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  find_fieldLength_fromFieldName(name,input_fieldName,parserObject_getd2bfields){
    var fieldName   = "";
    var fieldLength = "";
    for(var i=0; i<parserObject_getd2bfields.length; ++i){
      try{ fieldName   = parserObject_getd2bfields[i]["fieldName"];   }catch(err){ ; }
      try{ fieldLength = parserObject_getd2bfields[i]["fieldLength"]; }catch(err){ ; }
      if(fieldName===input_fieldName){
        //console.log(name+",fieldName="+fieldName+",fieldLength="+fieldLength);
        return fieldLength;
      }
    }
    //console.log(name+",fieldName="+fieldName+",fieldLength=200");
    return "200";
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  fieldNN_show(fn,ind){
    let fieldType = "";
    try{ fieldType = this.state.parserObject_getd2bfields[ind]["fieldType"]; }catch (err){ ; }
         if(fieldType === "ALPHANUM") { this.setState({ ["picker"+fn+"_isHidden"]:true,  ["textField"+fn+"_isHidden"]:false, ["textField"+fn+"_type"]:"text",   ["textField"+fn+"_text"]:this.fillD2bField(ind) }); }
    else if(fieldType === "UPRSTRING"){ this.setState({ ["picker"+fn+"_isHidden"]:true,  ["textField"+fn+"_isHidden"]:false, ["textField"+fn+"_type"]:"text",   ["textField"+fn+"_text"]:this.fillD2bField(ind) }); }
    else if(fieldType === "DIGIT")    { this.setState({ ["picker"+fn+"_isHidden"]:true,  ["textField"+fn+"_isHidden"]:false, ["textField"+fn+"_type"]:"text",   ["textField"+fn+"_text"]:this.fillD2bField(ind) }); } //number
    else if(fieldType === "COMBO")    { this.setState({ ["picker"+fn+"_isHidden"]:false, ["textField"+fn+"_isHidden"]:true,  }); this.prefil_combo(fn,this.fillD2bField(ind),ind);}
    else if(fieldType === "COMBO2")   { this.setState({ ["picker"+fn+"_isHidden"]:false, ["textField"+fn+"_isHidden"]:true,  }); this.prefil_combo(fn,this.fillD2bField(ind),ind);}
    else                              { }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  fieldNN_hide(fn,ind){
    this.setState({ ["picker"+fn+"_isHidden"]:true,  ["textField"+fn+"_isHidden"]:true});
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  get_child_combo_index(listType_parent){
    let methName = filename+"get_child_combo_index ";

    for(let i=0; i<this.state.parserObject_getd2bfields.length; ++i){
        let listType = null;
        try{ listType = this.state.parserObject_getd2bfields[i]["listType"]; }catch (err) { listType = null; }
        if(listType===listType_parent+1){
            if(api.print_logs){console.log(methName+"listType="+listType+",listType_parent="+listType_parent);}
            return i;
        }
    }
    return -1;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  comboNN_fillData(ind,listType_parent,comboValues){
    let methName = filename+"comboNN_fillData ";

    let fieldType = "";
    try{ fieldType = this.state.parserObject_getd2bfields[ind]["fieldType"]; }catch (err){ ; }
    let listType = null;
    try{ listType = this.state.parserObject_getd2bfields[ind]["listType"]; }catch (err) { listType = null; }

    if(listType===null)             { /*if(api.print_logs){console.log(methName+"ind="+ind+",listType="+listType+",fn="+fn+" [listType===null]");}              */ return; }
    if(listType_parent===null)      { /*if(api.print_logs){console.log(methName+"ind="+ind+",listType="+listType+",fn="+fn+" [listType_parent===null]");}       */ return; }
  //if(listType!==listType_parent+1){ /*if(api.print_logs){console.log(methName+"ind="+ind+",listType="+listType+",fn="+fn+" [listType!==listType_parent+1]");} */ return; }

    if(api.print_logs){console.log(methName+"ind="+ind+",listType="+listType+" [listType===listType_parent+1],fieldType="+fieldType);}
    if(fieldType === "COMBO" || fieldType === "COMBO2"){
      if(this.state.picker10_isHidden===false && ind===0) {this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker11_isHidden===false && ind===1) {this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker12_isHidden===false && ind===2) {this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker13_isHidden===false && ind===3) {this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker14_isHidden===false && ind===4) {this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker15_isHidden===false && ind===5) {this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker16_isHidden===false && ind===6) {this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker17_isHidden===false && ind===7) {this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker18_isHidden===false && ind===8) {this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker19_isHidden===false && ind===9) {this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker20_isHidden===false && ind===10){this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker21_isHidden===false && ind===11){this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
      if(this.state.picker22_isHidden===false && ind===12){this.state.parserObject_getd2bfields[ind]["comboValues"] = comboValues;}
    }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  comboNN_refresh(fn,ind,listType_parent){
    let methName = filename+"comboNN_refresh ";

    let fieldType = "";
    try{ fieldType = this.state.parserObject_getd2bfields[ind]["fieldType"]; }catch (err){ ; }
    let listType = null;
    try{ listType = this.state.parserObject_getd2bfields[ind]["listType"]; }catch (err) { listType = null; }

    if(listType===null)             { /*if(api.print_logs){console.log(methName+"ind="+ind+",listType="+listType+",fn="+fn+" [listType===null]");}              */ return; }
    if(listType_parent===null)      { /*if(api.print_logs){console.log(methName+"ind="+ind+",listType="+listType+",fn="+fn+" [listType_parent===null]");}       */ return; }
  //if(listType!==listType_parent+1){ /*if(api.print_logs){console.log(methName+"ind="+ind+",listType="+listType+",fn="+fn+" [listType!==listType_parent+1]");} */ return; }

    if(api.print_logs){console.log(methName+"ind="+ind+",listType="+listType+",fn="+fn+" [listType===listType_parent+1]");}
    if(fieldType === "COMBO" || fieldType === "COMBO2"){
      if(this.state.picker10_isHidden===false && ind===0) {this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker11_isHidden===false && ind===1) {this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker12_isHidden===false && ind===2) {this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker13_isHidden===false && ind===3) {this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker14_isHidden===false && ind===4) {this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker15_isHidden===false && ind===5) {this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker16_isHidden===false && ind===6) {this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker17_isHidden===false && ind===7) {this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker18_isHidden===false && ind===8) {this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker19_isHidden===false && ind===9) {this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker20_isHidden===false && ind===10){this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker21_isHidden===false && ind===11){this.prefil_combo(fn,this.fillD2bField(ind),ind);}
      if(this.state.picker22_isHidden===false && ind===12){this.prefil_combo(fn,this.fillD2bField(ind),ind);}
    }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  fillD2bField(ind){
    let methName = filename+"fillD2bField ";

    let parserObject_transhistorydetail_unique = null;
    try{ parserObject_transhistorydetail_unique = JSON.parse(localStorage.getItem("parserObject_transhistorydetail_unique")); } catch(err){;}
    //repeat transaction
    if(parserObject_transhistorydetail_unique!==null){
        let fieldName = "";
        try{ fieldName = this.state.parserObject_getd2bfields[ind]["fieldName"]; }catch (err){ ; }
        if(fieldName  === null || (typeof fieldName  ==="undefined")){fieldName  = "";}
        if(api.print_logs){console.log(methName+"fieldName="+fieldName+",ind="+ind);}

        for(let i=0; i<this.state.parserObject_getd2bfields.length; ++i){
            let fieldName_TMP  = "";
            let fieldValue_TMP = "";
            let fieldType_TMP  = "";
            try{ fieldName_TMP  = this.state.parserObject_getd2bfields[i]["fieldName"]; }catch (err){ ; }
            try{ fieldValue_TMP = this.state.parserObject_getd2bfields[i]["value"];     }catch (err){ ; }
            try{ fieldType_TMP  = this.state.parserObject_getd2bfields[i]["fieldType"]; }catch (err){ ; }
            if(fieldName_TMP  === null || (typeof fieldName_TMP  ==="undefined")){fieldName_TMP  = "";}
            if(fieldValue_TMP === null || (typeof fieldValue_TMP ==="undefined")){fieldValue_TMP = "";}
            if(fieldType_TMP  === null || (typeof fieldType_TMP  ==="undefined")){fieldType_TMP  = "";}
            if(fieldName===fieldName_TMP){
                if(api.print_logs){console.log(methName+"fieldName_TMP="+fieldName_TMP+" fieldValue_TMP="+fieldValue_TMP+" fieldType_TMP="+fieldType_TMP);}
                if(api.print_logs){console.log(methName+"fieldName="+fieldName+" fieldValue_TMP="+fieldValue_TMP);}
                return fieldValue_TMP;
            }
        }
    }
    return "";
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  prefil_combo(fn,val,ind){
      let methName = filename+"prefil_combo ";

      //OK// picker10_isHidden                                    : true,
      //OK// picker10_textFieldLabel1_text                        : "",
      //OK// picker10_textFieldLabel1_id                          : "",
      //OK// picker10_selIndex                                    : 0,
      //OK// parserObject_picker10_d2bObj                         : [],
      //OK// parserObject_picker10_d2bObj4picker                  : [],

      let comboValues_obj = [];
      let listType = null;
      try{ listType = this.state.parserObject_getd2bfields[ind]["listType"]; }catch (err) { listType = null; }
      if(listType===null){ try{ comboValues_obj = this.state.parserObject_getd2bfields[ind]["comboValues"]; }catch (err) { comboValues_obj = []; } }
      if(listType===1)   { try{ comboValues_obj = this.state.parserObject_getd2bfields[ind]["comboValues"]; }catch (err) { comboValues_obj = []; } }
      if(listType===2)   { try{ comboValues_obj = this.get_combo_comboValues_based_on_tIndex(ind,this.state.level1_tIndex_value); }catch (err) { comboValues_obj = []; } }
      if(listType===3)   { try{ comboValues_obj = this.get_combo_comboValues_based_on_tIndex(ind,this.state.level2_tIndex_value); }catch (err) { comboValues_obj = []; } }
      if(listType===4)   { try{ comboValues_obj = this.get_combo_comboValues_based_on_tIndex(ind,this.state.level3_tIndex_value); }catch (err) { comboValues_obj = []; } }
      if(listType===5)   { try{ comboValues_obj = this.get_combo_comboValues_based_on_tIndex(ind,this.state.level4_tIndex_value); }catch (err) { comboValues_obj = []; } }

      if(api.print_logs){console.log(methName+"fn="+fn+",val="+val+",ind="+ind+",listType="+listType);}

      //remove duplicates
      var comboValues_obj_duplicates_removed = [];
      var tIndex_array_TMP                   = [];
      var tIndex_TMP                         = "";
      for(var i=0; i<comboValues_obj.length; ++i){
        try{ tIndex_TMP = comboValues_obj[i]["tIndex"]; }catch (err) { ; }
        if(tIndex_TMP === null || (typeof tIndex_TMP === "undefined")){tIndex_TMP = "";}
        if(tIndex_TMP==="" || tIndex_array_TMP.includes(tIndex_TMP)===false){
          tIndex_array_TMP.push(tIndex_TMP);
          comboValues_obj_duplicates_removed.push(comboValues_obj[i]);
        }
      }
      comboValues_obj = comboValues_obj_duplicates_removed;

      //sort
      comboValues_obj = comboValues_obj.sort(function(obj1, obj2) {
        return obj1.fieldValue.localeCompare(obj2.fieldValue);
      });

      let comboValues_str = [];
      for(var i2=0; i2<comboValues_obj.length; ++i2){
        try{ comboValues_str.push(comboValues_obj[i2].fieldValue); } catch(err){;}
      }

      let fieldName = "";
      try{ fieldName = this.state.parserObject_getd2bfields[ind]["fieldName"]; }catch (err) { fieldName = ""; }
      if(fieldName === null || (typeof fieldName === "undefined")){fieldName = "";}

      this.setState({
        ["picker"+fn+"_textFieldLabel1_text"]       : this.get_combo_value(ind,val),
        ["picker"+fn+"_textFieldLabel1_id"]         : this.get_combo_id(ind,val),
        ["picker"+fn+"_selIndex"]                   : this.get_combo_index(ind,val),
        ["parserObject_picker"+fn+"_d2bObj"]        : comboValues_obj,
        ["parserObject_picker"+fn+"_d2bObj4picker"] : comboValues_str,
        ["picker"+fn+"_InputLabel"]                 : fieldName,
      });
      if(api.print_logs){console.log(methName+"fn="+fn+",val="+val+",ind="+ind);}
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  get_combo_index(pickerIndex,value){
    let methName = filename+"get_combo_index ";

    let comboValues = [];
    //try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"]; }catch (err) { ; }

    let listType = null;
    try{ listType = this.state.parserObject_getd2bfields[pickerIndex]["listType"]; }catch (err) { listType = null; }
    if(listType===null){ try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
    if(listType===1)   { try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
    if(listType===2)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level1_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===3)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level2_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===4)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level3_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===5)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level4_tIndex_value); }catch (err) { comboValues = []; } }

    let fieldCode  = "";
    let fieldValue = "";
    for(let i=0; i<comboValues.length; ++i){
        try{ fieldCode  = comboValues[i]["fieldCode"];  }catch (err) { ; }
        try{ fieldValue = comboValues[i]["fieldValue"]; }catch (err) { ; }
        if(fieldCode  === null || (typeof fieldCode  === "undefined")){fieldCode  = "";}
        if(fieldValue === null || (typeof fieldValue === "undefined")){fieldValue = "";}
        //if(api.print_logs){console.log(methName+"value="+value+",fieldValue="+fieldValue);}
        if(value === fieldCode){
            return i;
        }
    }
    if(api.print_logs){console.log(methName+"-----Was Really Not Found-----");}
    return -1;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  get_combo_id(pickerIndex,value){
    let methName = filename+"get_combo_id ";

    let comboValues = [];
    //try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"]; }catch (err) { ; }

    let listType = null;
    try{ listType = this.state.parserObject_getd2bfields[pickerIndex]["listType"]; }catch (err) { listType = null; }
    if(listType===null){ try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
    if(listType===1)   { try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
    if(listType===2)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level1_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===3)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level2_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===4)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level3_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===5)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level4_tIndex_value); }catch (err) { comboValues = []; } }

    if(api.print_logs){console.log(methName+"pickerIndex="+pickerIndex+",value="+value);}
    let fieldCode  = "";
    let fieldValue = "";
    for(let i=0; i<comboValues.length; ++i){
        try{ fieldCode  = comboValues[i]["fieldCode"];  }catch (err) { ; }
        try{ fieldValue = comboValues[i]["fieldValue"]; }catch (err) { ; }
        if(fieldCode  === null || (typeof fieldCode  === "undefined")){fieldCode  = "";}
        if(fieldValue === null || (typeof fieldValue === "undefined")){fieldValue = "";}
        //if(api.print_logs){console.log(methName+"value="+value+",fieldValue="+fieldValue);}
        if(value === fieldCode){
            return i;
        }
    }
    if(api.print_logs){console.log(methName+"-----Was Really Not Found-----");}
    return -1;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  get_combo_value(pickerIndex,value){
    let methName = filename+"get_combo_value ";

    let comboValues = [];
    //try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"]; }catch (err) { ; }

    let listType = null;
    try{ listType = this.state.parserObject_getd2bfields[pickerIndex]["listType"]; }catch (err) { listType = null; }
    if(listType===null){ try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
    if(listType===1)   { try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
    if(listType===2)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level1_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===3)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level2_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===4)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level3_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===5)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level4_tIndex_value); }catch (err) { comboValues = []; } }

    if(api.print_logs){console.log(methName+"pickerIndex="+pickerIndex+",value="+value);}
    let fieldCode  = "";
    let fieldValue = "";
    for(let i=0; i<comboValues.length; ++i){
        try{ fieldCode  = comboValues[i]["fieldCode"];  }catch (err) { ; }
        try{ fieldValue = comboValues[i]["fieldValue"]; }catch (err) { ; }
        if(fieldCode  === null || (typeof fieldCode  === "undefined")){fieldCode  = "";}
        if(fieldValue === null || (typeof fieldValue === "undefined")){fieldValue = "";}
        //if(api.print_logs){console.log(methName+"value="+value+",fieldValue="+fieldValue);}
        if(value === fieldCode){
            return fieldValue;
        }
    }
    if(api.print_logs){console.log(methName+"-----Was Really Not Found-----");}
    return "";
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  get_combo_tIndex(pickerIndex,selected_fieldValue){
    let methName = filename+"get_combo_tIndex ";

    let comboValues = [];
    //try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"]; }catch (err) { ; }

    let listType = null;
    try{ listType = this.state.parserObject_getd2bfields[pickerIndex]["listType"]; }catch (err) { listType = null; }
    if(listType===null){ try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
    if(listType===1)   { try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
    if(listType===2)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level1_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===3)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level2_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===4)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level3_tIndex_value); }catch (err) { comboValues = []; } }
    if(listType===5)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level4_tIndex_value); }catch (err) { comboValues = []; } }

    if(api.print_logs){console.log(methName+"pickerIndex="+pickerIndex+",selected_fieldValue="+selected_fieldValue);}
    let fieldValue = "";
    let tIndex     = "";
    for(let i=0; i<comboValues.length; ++i){
        try{ fieldValue = comboValues[i]["fieldValue"]; }catch (err) { ; }
        try{ tIndex     = comboValues[i]["tIndex"];     }catch (err) { ; }
        if(fieldValue === null || (typeof fieldValue === "undefined")){fieldValue = "";}
        if(tIndex     === null || (typeof tIndex     === "undefined")){tIndex     = "";}
        //if(api.print_logs){console.log(methName+"selected_fieldValue="+selected_fieldValue+",fieldValue="+fieldValue+",tIndex="+tIndex);}
        if(selected_fieldValue === fieldValue){
            return tIndex;
        }
    }
    if(api.print_logs){console.log(methName+"-----Was Really Not Found-----");}
    return "";
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  //-------------------------------------------------------------------------------------------------------------------------------
  //-------------------------------------------------------------------------------------------------------------------------------
  get_combo_comboValues_based_on_tIndex(pickerIndex,tIndexStr){
    let methName = filename+"get_combo_comboValues_based_on_tIndex ";

    if(tIndexStr===""){
      return [];
    }

    let comboValues  = [];
    try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"]; }catch (err) { ; }
    var comboValues_res = [];

    let fieldCode  = "";
    let fieldValue = "";
    let tIndex     = "";
    for(let i=0; i<comboValues.length; ++i){
        try{ fieldCode  = comboValues[i]["fieldCode"];  }catch (err) { ; }
        try{ fieldValue = comboValues[i]["fieldValue"]; }catch (err) { ; }
        try{ tIndex     = comboValues[i]["tIndex"];     }catch (err) { ; }
        if(fieldCode  === null || (typeof fieldCode  === "undefined")){fieldCode  = "";}
        if(fieldValue === null || (typeof fieldValue === "undefined")){fieldValue = "";}
        if(tIndex     === null || (typeof tIndex     === "undefined")){tIndex     = "";}
        //if(api.print_logs){console.log(methName+"tIndexStr="+tIndexStr+",fieldValue="+fieldValue+",tIndex="+tIndex);}
        if(tIndex.startsWith(tIndexStr+"_")){
            comboValues_res.push(comboValues[i]);
        }
    }
    if(api.print_logs){console.log(methName+"pickerIndex="+pickerIndex+",tIndexStr="+tIndexStr+",comboValues_res.length=="+comboValues_res.length);}
    return comboValues_res;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  //-------------------------------------------------------------------------------------------------------------------------------
  //-------------------------------------------------------------------------------------------------------------------------------
  hideCheckBox_checked(isChecked){
      if(isChecked){ this.setState({ "view_questCheckbox_isHidden":true ,"userCheckedTick":true }); }
      else         { this.setState({ "view_questCheckbox_isHidden":true ,"userCheckedTick":false });}
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  showCheckBox_checked(isChecked){
      if(isChecked){ this.setState({ "view_questCheckbox_isHidden":false ,"userCheckedTick": true }); }
      else         { this.setState({ "view_questCheckbox_isHidden":false ,"userCheckedTick": false }); }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  showSecurityQuestions(){
      this.setState({
        "textField3_isHidden": false,
        "textField4_isHidden": false,
      });
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  hideSecurityQuestions(){
      this.setState({
        "textField3_isHidden": true,
        "textField4_isHidden": true,
      });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_getPaymentReasons4Picker(event) {
    let methName = filename+"handleCustomDropDownClick_getPaymentReasons4Picker ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker1_textFieldLabel1_text" : eventTMP,
      "picker1_hasError"             : false,
    });
    //let lang = localStorage.getItem("lang"); //console.log('lang='+lang);
    for(let i=0; i<this.state.parserObject_getPaymentReasons.length; ++i){
    //if( (lang==="el" && this.state.parserObject_getPaymentReasons[i]["descr_el"]===eventTMP) || (lang==="en" && this.state.parserObject_getPaymentReasons[i]["descr_en"]===eventTMP) ){
      if( this.state.parserObject_getPaymentReasons[i]["descr_el"]===eventTMP || this.state.parserObject_getPaymentReasons[i]["descr_en"]===eventTMP ){
        this.setState({
          "picker1_selIndex"           : i,
          "picker1_textFieldLabel1_id" : this.state.parserObject_getPaymentReasons[i].reason_wu_id,
          "picker1_hasError"           : false,
        });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_getSourceOfFunds4Picker(event) {
    let methName = filename+"handleCustomDropDownClick_getSourceOfFunds4Picker ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker1b_textFieldLabel1_text" : eventTMP,
      "picker1b_hasError"             : false,
    });
    //let lang = localStorage.getItem("lang"); //console.log('lang='+lang);
    for(let i=0; i<this.state.parserObject_getSourceOfFunds.length; ++i){
    //if( (lang==="el" && this.state.parserObject_getSourceOfFunds[i]["descr_el"]===eventTMP) || (lang==="en" && this.state.parserObject_getSourceOfFunds[i]["descr_en"]===eventTMP) ){
      if( this.state.parserObject_getSourceOfFunds[i]["descr_el"]===eventTMP || this.state.parserObject_getSourceOfFunds[i]["descr_en"]===eventTMP ){
        this.setState({
          "picker1b_selIndex"           : i,
          "picker1b_textFieldLabel1_id" : this.state.parserObject_getSourceOfFunds[i].source_wu_id,
          "picker1b_hasError"           : false,
        });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_getRelationshipWithReceiver4Picker(event) {
    let methName = filename+"handleCustomDropDownClick_getRelationshipWithReceiver4Picker ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker1c_textFieldLabel1_text" : eventTMP,
      "picker1c_hasError"             : false,
    });
    //let lang = localStorage.getItem("lang"); //console.log('lang='+lang);
    for(let i=0; i<this.state.parserObject_getRelationshipWithReceiver.length; ++i){
    //if( (lang==="el" && this.state.parserObject_getRelationshipWithReceiver[i]["descr_el"]===eventTMP) || (lang==="en" && this.state.parserObject_getRelationshipWithReceiver[i]["descr_en"]===eventTMP) ){
      if( this.state.parserObject_getRelationshipWithReceiver[i]["descr_el"]===eventTMP || this.state.parserObject_getRelationshipWithReceiver[i]["descr_en"]===eventTMP ){
        this.setState({
          "picker1c_selIndex"           : i,
          "picker1c_textFieldLabel1_id" : this.state.parserObject_getRelationshipWithReceiver[i].relationship_wu_id,
          "picker1c_hasError"           : false,
        });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_getHandleBehalfThirdParty4Picker(event) {
    let methName = filename+"handleCustomDropDownClick_getHandleBehalfThirdParty4Picker ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}
    this.setState({
      "picker2_textFieldLabel1_text" : eventTMP,
      "picker2_hasError"             : false,
    });
    //let lang = localStorage.getItem("lang"); //console.log('lang='+lang);
    for(let i=0; i<this.state.parserObject_getBehalfThirdParty.length; ++i){
    //if( (lang==="el" && this.state.parserObject_getBehalfThirdParty[i]["descr_el"]===eventTMP) || (lang==="en" && this.state.parserObject_getBehalfThirdParty[i]["descr_en"]===eventTMP) ){
      if( this.state.parserObject_getBehalfThirdParty[i]["descr_el"]===eventTMP || this.state.parserObject_getBehalfThirdParty[i]["descr_en"]===eventTMP ){
        this.setState({
          "picker2_selIndex"           : i,
          "picker2_textFieldLabel1_id" : this.state.parserObject_getBehalfThirdParty[i].isBehalfThirdParty_wu_id,
          "picker2_hasError"           : false,
        });
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleCheckBoxClick_payWithoutDocs(event) {
    let methName = filename+"handleCheckBoxClick_payWithoutDocs ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    this.setState({
      "userCheckedTick"     :  event.target.checked,
      "textField3_isHidden" : event.target.checked===true? false : true,
      "textField4_isHidden" : event.target.checked===true? false : true,
    });
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  reset_child_dropDown(ind,eventTMP) {
    let methName = filename+"reset_child_dropDown ";

    let listType = null;
    try{ listType = this.state.parserObject_getd2bfields[ind]["listType"]; }catch (err) { listType = null; }
    if(listType===null){ if(api.print_logs){console.log(methName+"ind="+ind+",listType="+listType+",eventTMP="+eventTMP+"[listType===null]");} return; }

    let tIndex_value = this.get_combo_tIndex(ind,eventTMP);
    var ind_child  = this.get_child_combo_index(listType);
    if(api.print_logs){console.log(methName+"ind="+ind+",listType="+listType+",eventTMP="+eventTMP+",tIndex_value="+tIndex_value,"ind_child="+ind_child);}


    if(listType===1){
      this.setState({ "level1_tIndex_value":tIndex_value });
      this.setState({ "level2_tIndex_value":""           });
      this.setState({ "level3_tIndex_value":"",          });
      this.setState({ "level4_tIndex_value":"",          });
      this.setState({ "level5_tIndex_value":"",          });
    }
    if(listType===2){
      this.setState({ "level2_tIndex_value":tIndex_value });
      this.setState({ "level3_tIndex_value":""           });
      this.setState({ "level4_tIndex_value":""           });
      this.setState({ "level5_tIndex_value":""           });
    }
    if(listType===3){
      this.setState({ "level3_tIndex_value":tIndex_value });
      this.setState({ "level4_tIndex_value":""           });
      this.setState({ "level5_tIndex_value":""           });
    }
    if(listType===4){
      this.setState({ "level4_tIndex_value":tIndex_value });
      this.setState({ "level5_tIndex_value":""           });
    }
    if(listType===5){
      this.setState({ "level5_tIndex_value":tIndex_value });
    }

    if(ind_child===-1){
      return;
    }

    this.dialog200_handleOpen(this.NSInforString("networkerror"));//this.startSpinners();
    setTimeout(function() {
      if(api.print_logs){console.log(methName+"level1_tIndex_value="+this.state.level1_tIndex_value);}
      if(api.print_logs){console.log(methName+"level2_tIndex_value="+this.state.level2_tIndex_value);}
      if(api.print_logs){console.log(methName+"level3_tIndex_value="+this.state.level3_tIndex_value);}
      if(api.print_logs){console.log(methName+"level4_tIndex_value="+this.state.level4_tIndex_value);}
      if(api.print_logs){console.log(methName+"level5_tIndex_value="+this.state.level5_tIndex_value);}

      // if(ind<0) {this.comboNN_refresh("10",0, listType);}
      // if(ind<1) {this.comboNN_refresh("11",1, listType);}
      // if(ind<2) {this.comboNN_refresh("12",2, listType);}
      // if(ind<3) {this.comboNN_refresh("13",3, listType);}
      // if(ind<4) {this.comboNN_refresh("14",4, listType);}
      // if(ind<5) {this.comboNN_refresh("15",5, listType);}
      // if(ind<6) {this.comboNN_refresh("16",6, listType);}
      // if(ind<7) {this.comboNN_refresh("17",7, listType);}
      // if(ind<8) {this.comboNN_refresh("18",8, listType);}
      // if(ind<9) {this.comboNN_refresh("19",9, listType);}
      // if(ind<10){this.comboNN_refresh("20",10,listType);}
      // if(ind<11){this.comboNN_refresh("21",11,listType);}

      let TransferOnline1_selCountry      = JSON.parse(localStorage.getItem("TransferOnline1_selCountry"));
    //let TransferOnline1_selCurrencyDest = JSON.parse(localStorage.getItem("TransferOnline1_selCurrencyDest"));
    //let TransferOnline1_selState        = localStorage.getItem("TransferOnline1_selState")==="" ? null  : JSON.parse(localStorage.getItem("TransferOnline1_selState"));
    //let TransferOnline1_selCity         = localStorage.getItem("TransferOnline1_selCity") ==="" ? null  : JSON.parse(localStorage.getItem("TransferOnline1_selCity"));

      //--------------
      //wu_comboValues
      //--------------
      wu_TransactionFlow
      .wu_comboValues({country:TransferOnline1_selCountry["ctry_wu_id"],"parentTIndex":tIndex_value})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="TransferOnline2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
        //console.log(JSON.stringify(res.d2BFields[0].comboValues))
        if(api.print_logs){console.log(methName+"ind="+ind+",listType="+listType);}
        if(ind===0) {
          this.comboNN_fillData(1,  listType,[]);
          this.comboNN_fillData(2,  listType,[]);
          this.comboNN_fillData(3,  listType,[]);
          this.comboNN_fillData(4,  listType,[]);
          this.comboNN_fillData(5,  listType,[]);
          this.comboNN_fillData(6,  listType,[]);
          this.comboNN_fillData(7,  listType,[]);
          this.comboNN_fillData(8,  listType,[]);
          this.comboNN_fillData(9,  listType,[]);
          this.comboNN_fillData(10, listType,[]);
          this.comboNN_fillData(11, listType,[]);
          this.comboNN_fillData(ind_child, listType,res.d2BFields[0].comboValues);
        }
        if(ind===1) {
          this.comboNN_fillData(2,  listType,[]);
          this.comboNN_fillData(3,  listType,[]);
          this.comboNN_fillData(4,  listType,[]);
          this.comboNN_fillData(5,  listType,[]);
          this.comboNN_fillData(6,  listType,[]);
          this.comboNN_fillData(7,  listType,[]);
          this.comboNN_fillData(8,  listType,[]);
          this.comboNN_fillData(9,  listType,[]);
          this.comboNN_fillData(10, listType,[]);
          this.comboNN_fillData(11, listType,[]);
          this.comboNN_fillData(ind_child, listType,res.d2BFields[0].comboValues);
        }
        if(ind===2) {
          this.comboNN_fillData(3,  listType,[]);
          this.comboNN_fillData(4,  listType,[]);
          this.comboNN_fillData(5,  listType,[]);
          this.comboNN_fillData(6,  listType,[]);
          this.comboNN_fillData(7,  listType,[]);
          this.comboNN_fillData(8,  listType,[]);
          this.comboNN_fillData(9,  listType,[]);
          this.comboNN_fillData(10, listType,[]);
          this.comboNN_fillData(11, listType,[]);
          this.comboNN_fillData(ind_child, listType,res.d2BFields[0].comboValues);
        }
        if(ind===3) {
          this.comboNN_fillData(4,  listType,[]);
          this.comboNN_fillData(5,  listType,[]);
          this.comboNN_fillData(6,  listType,[]);
          this.comboNN_fillData(7,  listType,[]);
          this.comboNN_fillData(8,  listType,[]);
          this.comboNN_fillData(9,  listType,[]);
          this.comboNN_fillData(10, listType,[]);
          this.comboNN_fillData(11, listType,[]);
          this.comboNN_fillData(ind_child, listType,res.d2BFields[0].comboValues);
        }
        if(ind===4) {
          this.comboNN_fillData(5,  listType,[]);
          this.comboNN_fillData(6,  listType,[]);
          this.comboNN_fillData(7,  listType,[]);
          this.comboNN_fillData(8,  listType,[]);
          this.comboNN_fillData(9,  listType,[]);
          this.comboNN_fillData(10, listType,[]);
          this.comboNN_fillData(11, listType,[]);
          this.comboNN_fillData(ind_child, listType,res.d2BFields[0].comboValues);
        }
        if(ind===5) {
          this.comboNN_fillData(6,  listType,[]);
          this.comboNN_fillData(7,  listType,[]);
          this.comboNN_fillData(8,  listType,[]);
          this.comboNN_fillData(9,  listType,[]);
          this.comboNN_fillData(10, listType,[]);
          this.comboNN_fillData(11, listType,[]);
          this.comboNN_fillData(ind_child, listType,res.d2BFields[0].comboValues);
        }
        if(ind===6) {
          this.comboNN_fillData(7,  listType,[]);
          this.comboNN_fillData(8,  listType,[]);
          this.comboNN_fillData(9,  listType,[]);
          this.comboNN_fillData(10, listType,[]);
          this.comboNN_fillData(11, listType,[]);
          this.comboNN_fillData(ind_child, listType,res.d2BFields[0].comboValues);
        }
        if(ind===7) {
          this.comboNN_fillData(8,  listType,[]);
          this.comboNN_fillData(9,  listType,[]);
          this.comboNN_fillData(10, listType,[]);
          this.comboNN_fillData(11, listType,[]);
          this.comboNN_fillData(ind_child, listType,res.d2BFields[0].comboValues);
        }
        if(ind===8) {
          this.comboNN_fillData(9,  listType,[]);
          this.comboNN_fillData(10, listType,[]);
          this.comboNN_fillData(11, listType,[]);
          this.comboNN_fillData(ind_child, listType,res.d2BFields[0].comboValues);
        }
        if(ind===9) {
          this.comboNN_fillData(10, listType,[]);
          this.comboNN_fillData(11, listType,[]);
          this.comboNN_fillData(ind_child, listType,res.d2BFields[0].comboValues);
        }
        if(ind===10) {
          this.comboNN_fillData(11, listType,[]);
          this.comboNN_fillData(ind_child, listType,res.d2BFields[0].comboValues);
        }

        if(ind<0) {this.comboNN_refresh("10",0, listType);}
        if(ind<1) {this.comboNN_refresh("11",1, listType);}
        if(ind<2) {this.comboNN_refresh("12",2, listType);}
        if(ind<3) {this.comboNN_refresh("13",3, listType);}
        if(ind<4) {this.comboNN_refresh("14",4, listType);}
        if(ind<5) {this.comboNN_refresh("15",5, listType);}
        if(ind<6) {this.comboNN_refresh("16",6, listType);}
        if(ind<7) {this.comboNN_refresh("17",7, listType);}
        if(ind<8) {this.comboNN_refresh("18",8, listType);}
        if(ind<9) {this.comboNN_refresh("19",9, listType);}
        if(ind<10){this.comboNN_refresh("20",10,listType);}
        if(ind<11){this.comboNN_refresh("21",11,listType);}
      })
      .catch(err => {
        this.stopLockers();this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }.bind(this), 100);
  }
  //----------------------------------------------------------------------------------------------------
  handleCustomDropDownClick_picker10(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker10_textFieldLabel1_text":eventTMP, "picker10_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker10_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker10_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker10_selIndex" : i });
        this.reset_child_dropDown(0,eventTMP);
        break;
      }
    }
  }
  handleCustomDropDownClick_picker11(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker11_textFieldLabel1_text":eventTMP, "picker11_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker11_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker11_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker11_selIndex" : i });
        this.reset_child_dropDown(1,eventTMP);
        break;
      }
    }
  }
  handleCustomDropDownClick_picker12(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker12_textFieldLabel1_text":eventTMP, "picker12_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker12_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker12_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker12_selIndex" : i });
        this.reset_child_dropDown(2,eventTMP);
        break;
      }
    }
  }
  handleCustomDropDownClick_picker13(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker13_textFieldLabel1_text":eventTMP, "picker13_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker13_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker13_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker13_selIndex" : i });
        this.reset_child_dropDown(3,eventTMP);
        break;
      }
    }
  }
  handleCustomDropDownClick_picker14(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker14_textFieldLabel1_text":eventTMP, "picker14_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker14_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker14_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker14_selIndex" : i });
        this.reset_child_dropDown(4,eventTMP);
        break;
      }
    }
  }
  handleCustomDropDownClick_picker15(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker15_textFieldLabel1_text":eventTMP, "picker15_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker15_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker15_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker15_selIndex" : i });
        this.reset_child_dropDown(5,eventTMP);
        break;
      }
    }
  }
  handleCustomDropDownClick_picker16(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker16_textFieldLabel1_text":eventTMP, "picker16_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker16_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker16_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker16_selIndex" : i });
        this.reset_child_dropDown(6,eventTMP);
        break;
      }
    }
  }
  handleCustomDropDownClick_picker17(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker17_textFieldLabel1_text":eventTMP, "picker17_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker17_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker17_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker17_selIndex" : i });
        this.reset_child_dropDown(7,eventTMP);
        break;
      }
    }
  }
  handleCustomDropDownClick_picker18(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker18_textFieldLabel1_text":eventTMP, "picker18_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker18_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker18_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker18_selIndex" : i });
        this.reset_child_dropDown(8,eventTMP);
        break;
      }
    }
  }
  handleCustomDropDownClick_picker19(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker19_textFieldLabel1_text":eventTMP, "picker19_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker19_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker19_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker19_selIndex" : i });
        this.reset_child_dropDown(9,eventTMP);
        break;
      }
    }
  }
  handleCustomDropDownClick_picker20(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker20_textFieldLabel1_text":eventTMP, "picker20_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker20_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker20_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker20_selIndex" : i });
        this.reset_child_dropDown(10,eventTMP);
        break;
      }
    }
  }
  handleCustomDropDownClick_picker21(event) {
    let eventTMP = event.target.value+"";
    this.setState({ "picker21_textFieldLabel1_text":eventTMP, "picker21_hasError":false, });
    for(let i=0; i<this.state.parserObject_picker21_d2bObj4picker.length; ++i){
      if(this.state.parserObject_picker21_d2bObj4picker[i]===eventTMP){
        this.setState({ "picker21_selIndex" : i });
        this.reset_child_dropDown(11,eventTMP);
        break;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_next_act_isDisabled(){
    // if(this.verifyLength(this.state.textField1,1)===false){ return true; } //firstName
    // if(this.verifyLength(this.state.textField2,1)===false){ return true; } //lastName
    //
    // if(this.state.picker1_textFieldLabel1_id===""){ return true; } //sourceOfFunds
    //
    // if(this.state.picker1b_isHidden===false){ //sourceOfFunds
    //     if(this.state.picker1b_textFieldLabel1_id === ""){ return true; }
    // }
    // if(this.state.picker1c_isHidden===false){ //relationshipWithReceiver
    //     if(this.state.picker1c_textFieldLabel1_id === ""){ return true; }
    // }
    //
    // if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
    //     let d2bCnt = this.state.parserObject_getd2bfields.length;
    //     let required_10 = false; if(d2bCnt>0){ try{ required_10 = this.state.parserObject_getd2bfields[0]["required"]; }catch(err){ ; } }
    //     let required_11 = false; if(d2bCnt>1){ try{ required_11 = this.state.parserObject_getd2bfields[1]["required"]; }catch(err){ ; } }
    //     let required_12 = false; if(d2bCnt>2){ try{ required_12 = this.state.parserObject_getd2bfields[2]["required"]; }catch(err){ ; } }
    //     let required_13 = false; if(d2bCnt>3){ try{ required_13 = this.state.parserObject_getd2bfields[3]["required"]; }catch(err){ ; } }
    //     let required_14 = false; if(d2bCnt>4){ try{ required_14 = this.state.parserObject_getd2bfields[4]["required"]; }catch(err){ ; } }
    //     let required_15 = false; if(d2bCnt>5){ try{ required_15 = this.state.parserObject_getd2bfields[5]["required"]; }catch(err){ ; } }
    //     let required_16 = false; if(d2bCnt>6){ try{ required_16 = this.state.parserObject_getd2bfields[6]["required"]; }catch(err){ ; } }
    //     let required_17 = false; if(d2bCnt>7){ try{ required_17 = this.state.parserObject_getd2bfields[7]["required"]; }catch(err){ ; } }
    //     let required_18 = false; if(d2bCnt>8){ try{ required_18 = this.state.parserObject_getd2bfields[8]["required"]; }catch(err){ ; } }
    //     let required_19 = false; if(d2bCnt>9){ try{ required_19 = this.state.parserObject_getd2bfields[9]["required"]; }catch(err){ ; } }
    //     let required_20 = false; if(d2bCnt>9){ try{ required_20 = this.state.parserObject_getd2bfields[9]["required"]; }catch(err){ ; } }
    //     let required_21 = false; if(d2bCnt>9){ try{ required_21 = this.state.parserObject_getd2bfields[9]["required"]; }catch(err){ ; } }
    //
    //          if(this.state.textField10_isHidden===false && (this.state.textField10_text === "") && required_10){ return true; }
    //     else if(this.state.textField11_isHidden===false && (this.state.textField11_text === "") && required_11){ return true; }
    //     else if(this.state.textField12_isHidden===false && (this.state.textField12_text === "") && required_12){ return true; }
    //     else if(this.state.textField13_isHidden===false && (this.state.textField13_text === "") && required_13){ return true; }
    //     else if(this.state.textField14_isHidden===false && (this.state.textField14_text === "") && required_14){ return true; }
    //     else if(this.state.textField15_isHidden===false && (this.state.textField15_text === "") && required_15){ return true; }
    //     else if(this.state.textField16_isHidden===false && (this.state.textField16_text === "") && required_16){ return true; }
    //     else if(this.state.textField17_isHidden===false && (this.state.textField17_text === "") && required_17){ return true; }
    //     else if(this.state.textField18_isHidden===false && (this.state.textField18_text === "") && required_18){ return true; }
    //     else if(this.state.textField19_isHidden===false && (this.state.textField19_text === "") && required_19){ return true; }
    //     else if(this.state.textField20_isHidden===false && (this.state.textField20_text === "") && required_20){ return true; }
    //     else if(this.state.textField21_isHidden===false && (this.state.textField21_text === "") && required_21){ return true; }
    //
    //          if(this.state.picker10_isHidden===false && (this.state.picker10_textFieldLabel1_text === "") && required_10){ return true; }
    //     else if(this.state.picker11_isHidden===false && (this.state.picker11_textFieldLabel1_text === "") && required_11){ return true; }
    //     else if(this.state.picker12_isHidden===false && (this.state.picker12_textFieldLabel1_text === "") && required_12){ return true; }
    //     else if(this.state.picker13_isHidden===false && (this.state.picker13_textFieldLabel1_text === "") && required_13){ return true; }
    //     else if(this.state.picker14_isHidden===false && (this.state.picker14_textFieldLabel1_text === "") && required_14){ return true; }
    //     else if(this.state.picker15_isHidden===false && (this.state.picker15_textFieldLabel1_text === "") && required_15){ return true; }
    //     else if(this.state.picker16_isHidden===false && (this.state.picker16_textFieldLabel1_text === "") && required_16){ return true; }
    //     else if(this.state.picker17_isHidden===false && (this.state.picker17_textFieldLabel1_text === "") && required_17){ return true; }
    //     else if(this.state.picker18_isHidden===false && (this.state.picker18_textFieldLabel1_text === "") && required_18){ return true; }
    //     else if(this.state.picker19_isHidden===false && (this.state.picker19_textFieldLabel1_text === "") && required_19){ return true; }
    //     else if(this.state.picker20_isHidden===false && (this.state.picker20_textFieldLabel1_text === "") && required_20){ return true; }
    //     else if(this.state.picker21_isHidden===false && (this.state.picker21_textFieldLabel1_text === "") && required_21){ return true; }
    // }

    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_next_act(event) {
    let methName = filename+"btn_next_act ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.textField1.trim() === "") { this.setState({"textField1_hasError" : true }); emptyFields = true; }
      if(this.state.textField2.trim() === "") { this.setState({"textField2_hasError" : true }); emptyFields = true; }
      if(this.state.textField3_isHidden===false){
        if(this.state.textField3.trim() === "") { this.setState({"textField3_hasError" : true }); emptyFields = true; }
      }
      if(this.state.textField4_isHidden===false){
        if(this.state.textField4.trim() === "") { this.setState({"textField4_hasError" : true }); emptyFields = true; }
      }
      if(this.state.textField5_isHidden===false){
        if(this.state.textField5.trim() === "") { this.setState({"textField5_hasError" : true }); emptyFields = true; }
      }
      if(this.state.picker1_textFieldLabel1_text.trim() === "") { this.setState({"picker1_hasError" : true }); emptyFields = true; }

      if(this.state.picker1b_isHidden===false){
          if(this.state.picker1b_textFieldLabel1_id === ""){ this.setState({"picker1b_hasError":true,}); emptyFields = true; }
      }
      if(this.state.picker1c_isHidden===false){
          if(this.state.picker1c_textFieldLabel1_id === ""){ this.setState({"picker1c_hasError":true}); emptyFields = true; }
      }
      if(api.shouldUseSMSVerify202104===true){
        if(this.state.picker2_textFieldLabel1_text.trim() === "") { this.setState({"picker2_hasError" : true }); emptyFields = true; }
      }

      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let d2bCnt = this.state.parserObject_getd2bfields.length;
          let required_10 = false; if(d2bCnt>0){ try{ required_10 = this.state.parserObject_getd2bfields[0]["required"];  }catch(err){ ; } }
          let required_11 = false; if(d2bCnt>1){ try{ required_11 = this.state.parserObject_getd2bfields[1]["required"];  }catch(err){ ; } }
          let required_12 = false; if(d2bCnt>2){ try{ required_12 = this.state.parserObject_getd2bfields[2]["required"];  }catch(err){ ; } }
          let required_13 = false; if(d2bCnt>3){ try{ required_13 = this.state.parserObject_getd2bfields[3]["required"];  }catch(err){ ; } }
          let required_14 = false; if(d2bCnt>4){ try{ required_14 = this.state.parserObject_getd2bfields[4]["required"];  }catch(err){ ; } }
          let required_15 = false; if(d2bCnt>5){ try{ required_15 = this.state.parserObject_getd2bfields[5]["required"];  }catch(err){ ; } }
          let required_16 = false; if(d2bCnt>6){ try{ required_16 = this.state.parserObject_getd2bfields[6]["required"];  }catch(err){ ; } }
          let required_17 = false; if(d2bCnt>7){ try{ required_17 = this.state.parserObject_getd2bfields[7]["required"];  }catch(err){ ; } }
          let required_18 = false; if(d2bCnt>8){ try{ required_18 = this.state.parserObject_getd2bfields[8]["required"];  }catch(err){ ; } }
          let required_19 = false; if(d2bCnt>9){ try{ required_19 = this.state.parserObject_getd2bfields[9]["required"];  }catch(err){ ; } }
          let required_20 = false; if(d2bCnt>9){ try{ required_20 = this.state.parserObject_getd2bfields[10]["required"]; }catch(err){ ; } }
          let required_21 = false; if(d2bCnt>9){ try{ required_21 = this.state.parserObject_getd2bfields[11]["required"]; }catch(err){ ; } }

          if(this.state.textField10_isHidden===false && (this.state.textField10_text === "") && required_10){ this.setState({"textField10_hasError":true}); emptyFields = true; }
          if(this.state.textField11_isHidden===false && (this.state.textField11_text === "") && required_11){ this.setState({"textField11_hasError":true}); emptyFields = true; }
          if(this.state.textField12_isHidden===false && (this.state.textField12_text === "") && required_12){ this.setState({"textField12_hasError":true}); emptyFields = true; }
          if(this.state.textField13_isHidden===false && (this.state.textField13_text === "") && required_13){ this.setState({"textField13_hasError":true}); emptyFields = true; }
          if(this.state.textField14_isHidden===false && (this.state.textField14_text === "") && required_14){ this.setState({"textField14_hasError":true}); emptyFields = true; }
          if(this.state.textField15_isHidden===false && (this.state.textField15_text === "") && required_15){ this.setState({"textField15_hasError":true}); emptyFields = true; }
          if(this.state.textField16_isHidden===false && (this.state.textField16_text === "") && required_16){ this.setState({"textField16_hasError":true}); emptyFields = true; }
          if(this.state.textField17_isHidden===false && (this.state.textField17_text === "") && required_17){ this.setState({"textField17_hasError":true}); emptyFields = true; }
          if(this.state.textField18_isHidden===false && (this.state.textField18_text === "") && required_18){ this.setState({"textField18_hasError":true}); emptyFields = true; }
          if(this.state.textField19_isHidden===false && (this.state.textField19_text === "") && required_19){ this.setState({"textField19_hasError":true}); emptyFields = true; }
          if(this.state.textField20_isHidden===false && (this.state.textField20_text === "") && required_20){ this.setState({"textField20_hasError":true}); emptyFields = true; }
          if(this.state.textField21_isHidden===false && (this.state.textField21_text === "") && required_21){ this.setState({"textField21_hasError":true}); emptyFields = true; }

          if(this.state.picker10_isHidden===false && (this.state.picker10_textFieldLabel1_text === "") && required_10){ this.setState({"picker10_hasError":true}); emptyFields = true; }
          if(this.state.picker11_isHidden===false && (this.state.picker11_textFieldLabel1_text === "") && required_11){ this.setState({"picker11_hasError":true}); emptyFields = true; }
          if(this.state.picker12_isHidden===false && (this.state.picker12_textFieldLabel1_text === "") && required_12){ this.setState({"picker12_hasError":true}); emptyFields = true; }
          if(this.state.picker13_isHidden===false && (this.state.picker13_textFieldLabel1_text === "") && required_13){ this.setState({"picker13_hasError":true}); emptyFields = true; }
          if(this.state.picker14_isHidden===false && (this.state.picker14_textFieldLabel1_text === "") && required_14){ this.setState({"picker14_hasError":true}); emptyFields = true; }
          if(this.state.picker15_isHidden===false && (this.state.picker15_textFieldLabel1_text === "") && required_15){ this.setState({"picker15_hasError":true}); emptyFields = true; }
          if(this.state.picker16_isHidden===false && (this.state.picker16_textFieldLabel1_text === "") && required_16){ this.setState({"picker16_hasError":true}); emptyFields = true; }
          if(this.state.picker17_isHidden===false && (this.state.picker17_textFieldLabel1_text === "") && required_17){ this.setState({"picker17_hasError":true}); emptyFields = true; }
          if(this.state.picker18_isHidden===false && (this.state.picker18_textFieldLabel1_text === "") && required_18){ this.setState({"picker18_hasError":true}); emptyFields = true; }
          if(this.state.picker19_isHidden===false && (this.state.picker19_textFieldLabel1_text === "") && required_19){ this.setState({"picker19_hasError":true}); emptyFields = true; }
          if(this.state.picker20_isHidden===false && (this.state.picker20_textFieldLabel1_text === "") && required_20){ this.setState({"picker20_hasError":true}); emptyFields = true; }
          if(this.state.picker21_isHidden===false && (this.state.picker21_textFieldLabel1_text === "") && required_21){ this.setState({"picker21_hasError":true}); emptyFields = true; }
      }
      if(emptyFields===true){return;}
    }



    //------------------
    //validate uploadPDF
    //------------------
    let shouldUploadPDF = "false";
    let parserObject_checkuploadedID = JSON.parse(localStorage.getItem("parserObject_checkuploadedID"));
    try{ shouldUploadPDF = parserObject_checkuploadedID["returnText"]; } catch(err){;}
    if(shouldUploadPDF==="true"){
        //this.dialog_handleOpen(this.NSInforString("TransferOnline2_msg_shouldUploadPDF"));
        this.dialogYN_handleOpen(this.NSInforString("TransferOnline2_msg_shouldUploadPDF_with_nav"));
        return;
    }
    //------------------
    //validate firstName---TextField
    //------------------
    let textField1text = this.state.textField1.trim();
    if(textField1text === ""){ //VLDT:empty
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline2_plh1")+"\"");
        this.setState({"textField1_hasError" : true });
        return;
    }
    if(wu_Utilities.offline_validate_latinCharacters(textField1text.replace(/ /g,""))===false){
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline2_plh1")+"\" "+this.NSInforString("with_latin"));
        this.setState({"textField1_hasError" : true });
        return;
    }
    if(textField1text.length < 2 || textField1text.length > 36 ){
        this.dialog_handleOpen(this.NSInforString("common.firstName.size"));
        this.setState({"textField1_hasError" : true });
        return;
    }
    //-----------------
    //validate lastName---TextField
    //-----------------
    let textField2text = this.state.textField2.trim();
    if(textField2text  === ""){ //VLDT:empty
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline2_plh2")+"\"");
        this.setState({"textField2_hasError" : true });
        return;
    }
    if(wu_Utilities.offline_validate_latinCharacters(textField2text.replace(/ /g,""))===false){
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline2_plh2")+"\" "+this.NSInforString("with_latin"));
        this.setState({"textField2_hasError" : true });
        return;
    }
    if(textField2text.length < 2 || textField2text.length > 36){
        this.dialog_handleOpen(this.NSInforString("common.lastName.size"));
        this.setState({"textField2_hasError" : true });
        return;
    }
    //---------------------------
    //validate firstName+lastName---TextField
    //---------------------------
    if(textField1text.length + textField2text.length > 39){
      this.dialog_handleOpen(this.NSInforString("common.firstlastName.size"));
      this.setState({"textField1_hasError" : true });
      this.setState({"textField2_hasError" : true });
      return;
    }
    //----------------------
    //validate PaymentReason---Picker
    //----------------------
    let reason_wu_id = this.state.picker1_textFieldLabel1_id;
    if(reason_wu_id === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline2_pic1"));
        this.setState({"picker1_hasError":true});
        return;
    }
    //----------------------
    //validate sourceOfFunds---Picker
    //----------------------
    let source_wu_id = this.state.picker1b_textFieldLabel1_id;
    if(this.state.picker1b_isHidden===false){
        if(source_wu_id === ""){
            this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline2_pic1b"));
            this.setState({"picker1b_hasError":true,});
            return;
        }
    }
    //---------------------------------
    //validate relationshipWithReceiver---Picker
    //---------------------------------
    let relationship_wu_id = this.state.picker1c_textFieldLabel1_id;
    if(this.state.picker1c_isHidden===false){
      if(relationship_wu_id === ""){
        this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline2_pic1c"));
        this.setState({"picker1c_hasError":true,});
        return;
      }
    }
    //-------------------------
    //validate BehalfThirdParty---Picker
    //-------------------------
    let isBehalfThirdParty_wu_id = "";
    if(api.shouldUseSMSVerify202104===true){
      isBehalfThirdParty_wu_id = this.state.picker2_textFieldLabel1_id;
      if(isBehalfThirdParty_wu_id === ""){
          this.dialog_handleOpen(this.NSInforString("emtpy_picker")+this.NSInforString("TransferOnline2_pic2"));
          this.setState({"picker2_hasError":true});
          return;
      }
    }
    //------------
    //validate AFM---TextField
    //------------
    if(this.state.textField5_isHidden===false){
      let textField5text = this.state.textField5.trim();
      if(textField5text === ""){ //VLDT:empty
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline2_plh5")+"\"");
        this.setState({"textField5_hasError" : true });
        return;
      }
    }

    if(this.state.textField3_isHidden===false && this.state.textField4_isHidden===false){
        //--------------------------
        //validate Security QUESTION---TextField
        //--------------------------
        let textField3text = this.state.textField3.trim();
        if(textField3text === ""){ //VLDT:empty
            this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline2_plh3")+"\"");
            this.setState({"textField3_hasError" : true });
            return;
        }
        if(wu_Utilities.offline_validate_latinCharacters(textField3text.replace(/ /g,""))===false){
            this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline2_plh3")+"\" "+this.NSInforString("with_latin"));
            this.setState({"textField3_hasError" : true });
            return;
        }
        // if(textField3text.length > 50){//VLDT:size
        //     this.dialog_handleOpen(this.NSInforString("common.securityQuestion.size"));
        //     this.setState({"textField3_hasError" : true });
        //     return;
        // }
        //------------------------
        //validate Security ANSWER---TextField
        //------------------------
        let textField4text = this.state.textField4.trim();
        if(textField4text === ""){ //VLDT:empty
            this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline2_plh4")+"\"");
            this.setState({"textField4_hasError" : true });
            return;
        }
        if(wu_Utilities.offline_validate_latinCharacters(textField4text.replace(/ /g,""))===false){
            this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline2_plh4")+"\" "+this.NSInforString("with_latin"));
            this.setState({"textField4_hasError" : true });
            return;
        }
        // if(textField4text.length > 50){//VLDT:size
        //     this.dialog_handleOpen(this.NSInforString("common.securityAnswer.size"));
        //     this.setState({"textField4_hasError" : true });
        //     return;
        // }
        //---------------------------------
        //validate Security QUESTION/ANSWER
        //---------------------------------
        if(textField4text.length+textField3text.length > 39){//VLDT:size
            this.dialog_handleOpen(this.NSInforString("common.securityQuestionAnswer.size"));
            this.setState({
              "textField3_hasError" : true,
              "textField4_hasError" : true,
            });
            return;
        }
    }
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
      let d2bCnt = this.state.parserObject_getd2bfields.length;
      let required_10 = false; if(d2bCnt>0) { try{ required_10 = this.state.parserObject_getd2bfields[0]["required"];  }catch(err){ ; } }
      let required_11 = false; if(d2bCnt>1) { try{ required_11 = this.state.parserObject_getd2bfields[1]["required"];  }catch(err){ ; } }
      let required_12 = false; if(d2bCnt>2) { try{ required_12 = this.state.parserObject_getd2bfields[2]["required"];  }catch(err){ ; } }
      let required_13 = false; if(d2bCnt>3) { try{ required_13 = this.state.parserObject_getd2bfields[3]["required"];  }catch(err){ ; } }
      let required_14 = false; if(d2bCnt>4) { try{ required_14 = this.state.parserObject_getd2bfields[4]["required"];  }catch(err){ ; } }
      let required_15 = false; if(d2bCnt>5) { try{ required_15 = this.state.parserObject_getd2bfields[5]["required"];  }catch(err){ ; } }
      let required_16 = false; if(d2bCnt>6) { try{ required_16 = this.state.parserObject_getd2bfields[6]["required"];  }catch(err){ ; } }
      let required_17 = false; if(d2bCnt>7) { try{ required_17 = this.state.parserObject_getd2bfields[7]["required"];  }catch(err){ ; } }
      let required_18 = false; if(d2bCnt>8) { try{ required_18 = this.state.parserObject_getd2bfields[8]["required"];  }catch(err){ ; } }
      let required_19 = false; if(d2bCnt>9) { try{ required_19 = this.state.parserObject_getd2bfields[9]["required"];  }catch(err){ ; } }
      let required_20 = false; if(d2bCnt>10){ try{ required_20 = this.state.parserObject_getd2bfields[10]["required"]; }catch(err){ ; } }
      let required_21 = false; if(d2bCnt>11){ try{ required_21 = this.state.parserObject_getd2bfields[11]["required"]; }catch(err){ ; } }

      // let fieldLength_10 = 0; if(d2bCnt>0) { try{ fieldLength_10 = parseInt(this.state.parserObject_getd2bfields[0]["fieldLength"]);  }catch(err){ fieldLength_10 = 0; } }
      // let fieldLength_11 = 0; if(d2bCnt>1) { try{ fieldLength_11 = parseInt(this.state.parserObject_getd2bfields[1]["fieldLength"]);  }catch(err){ fieldLength_11 = 0; } }
      // let fieldLength_12 = 0; if(d2bCnt>2) { try{ fieldLength_12 = parseInt(this.state.parserObject_getd2bfields[2]["fieldLength"]);  }catch(err){ fieldLength_12 = 0; } }
      // let fieldLength_13 = 0; if(d2bCnt>3) { try{ fieldLength_13 = parseInt(this.state.parserObject_getd2bfields[3]["fieldLength"]);  }catch(err){ fieldLength_13 = 0; } }
      // let fieldLength_14 = 0; if(d2bCnt>4) { try{ fieldLength_14 = parseInt(this.state.parserObject_getd2bfields[4]["fieldLength"]);  }catch(err){ fieldLength_14 = 0; } }
      // let fieldLength_15 = 0; if(d2bCnt>5) { try{ fieldLength_15 = parseInt(this.state.parserObject_getd2bfields[5]["fieldLength"]);  }catch(err){ fieldLength_15 = 0; } }
      // let fieldLength_16 = 0; if(d2bCnt>6) { try{ fieldLength_16 = parseInt(this.state.parserObject_getd2bfields[6]["fieldLength"]);  }catch(err){ fieldLength_16 = 0; } }
      // let fieldLength_17 = 0; if(d2bCnt>7) { try{ fieldLength_17 = parseInt(this.state.parserObject_getd2bfields[7]["fieldLength"]);  }catch(err){ fieldLength_17 = 0; } }
      // let fieldLength_18 = 0; if(d2bCnt>8) { try{ fieldLength_18 = parseInt(this.state.parserObject_getd2bfields[8]["fieldLength"]);  }catch(err){ fieldLength_18 = 0; } }
      // let fieldLength_19 = 0; if(d2bCnt>9) { try{ fieldLength_19 = parseInt(this.state.parserObject_getd2bfields[9]["fieldLength"]);  }catch(err){ fieldLength_19 = 0; } }
      // let fieldLength_20 = 0; if(d2bCnt>10){ try{ fieldLength_20 = parseInt(this.state.parserObject_getd2bfields[10]["fieldLength"]); }catch(err){ fieldLength_20 = 0; } }
      // let fieldLength_21 = 0; if(d2bCnt>11){ try{ fieldLength_21 = parseInt(this.state.parserObject_getd2bfields[11]["fieldLength"]); }catch(err){ fieldLength_21 = 0; } }
      let fieldLength_10 = 0; if(d2bCnt>0) { try{ fieldLength_10 = parseInt(this.find_fieldLength_fromFieldName("10",this.state.textField10_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_10 = 200; } }
      let fieldLength_11 = 0; if(d2bCnt>1) { try{ fieldLength_11 = parseInt(this.find_fieldLength_fromFieldName("11",this.state.textField11_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_11 = 200; } }
      let fieldLength_12 = 0; if(d2bCnt>2) { try{ fieldLength_12 = parseInt(this.find_fieldLength_fromFieldName("12",this.state.textField12_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_12 = 200; } }
      let fieldLength_13 = 0; if(d2bCnt>3) { try{ fieldLength_13 = parseInt(this.find_fieldLength_fromFieldName("13",this.state.textField13_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_13 = 200; } }
      let fieldLength_14 = 0; if(d2bCnt>4) { try{ fieldLength_14 = parseInt(this.find_fieldLength_fromFieldName("14",this.state.textField14_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_14 = 200; } }
      let fieldLength_15 = 0; if(d2bCnt>5) { try{ fieldLength_15 = parseInt(this.find_fieldLength_fromFieldName("15",this.state.textField15_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_15 = 200; } }
      let fieldLength_16 = 0; if(d2bCnt>6) { try{ fieldLength_16 = parseInt(this.find_fieldLength_fromFieldName("16",this.state.textField16_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_16 = 200; } }
      let fieldLength_17 = 0; if(d2bCnt>7) { try{ fieldLength_17 = parseInt(this.find_fieldLength_fromFieldName("17",this.state.textField17_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_17 = 200; } }
      let fieldLength_18 = 0; if(d2bCnt>8) { try{ fieldLength_18 = parseInt(this.find_fieldLength_fromFieldName("18",this.state.textField18_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_18 = 200; } }
      let fieldLength_19 = 0; if(d2bCnt>9) { try{ fieldLength_19 = parseInt(this.find_fieldLength_fromFieldName("19",this.state.textField19_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_19 = 200; } }
      let fieldLength_20 = 0; if(d2bCnt>10){ try{ fieldLength_20 = parseInt(this.find_fieldLength_fromFieldName("20",this.state.textField20_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_20 = 200; } }
      let fieldLength_21 = 0; if(d2bCnt>11){ try{ fieldLength_21 = parseInt(this.find_fieldLength_fromFieldName("21",this.state.textField21_plh,this.state.parserObject_getd2bfields));  }catch(err){ fieldLength_21 = 200; } }

            if(this.state.textField10_isHidden===false && (this.state.textField10_text === "") && required_10){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField10_plh+"\""); return; }
       else if(this.state.textField11_isHidden===false && (this.state.textField11_text === "") && required_11){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField11_plh+"\""); return; }
       else if(this.state.textField12_isHidden===false && (this.state.textField12_text === "") && required_12){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField12_plh+"\""); return; }
       else if(this.state.textField13_isHidden===false && (this.state.textField13_text === "") && required_13){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField13_plh+"\""); return; }
       else if(this.state.textField14_isHidden===false && (this.state.textField14_text === "") && required_14){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField14_plh+"\""); return; }
       else if(this.state.textField15_isHidden===false && (this.state.textField15_text === "") && required_15){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField15_plh+"\""); return; }
       else if(this.state.textField16_isHidden===false && (this.state.textField16_text === "") && required_16){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField16_plh+"\""); return; }
       else if(this.state.textField17_isHidden===false && (this.state.textField17_text === "") && required_17){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField17_plh+"\""); return; }
       else if(this.state.textField18_isHidden===false && (this.state.textField18_text === "") && required_18){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField18_plh+"\""); return; }
       else if(this.state.textField19_isHidden===false && (this.state.textField19_text === "") && required_19){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField19_plh+"\""); return; }
       else if(this.state.textField20_isHidden===false && (this.state.textField20_text === "") && required_20){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField20_plh+"\""); return; }
       else if(this.state.textField21_isHidden===false && (this.state.textField21_text === "") && required_21){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField21_plh+"\""); return; }

           if(this.state.textField10_isHidden===false && (this.state.textField10_text.length>fieldLength_10) && required_10 && fieldLength_10>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_10+"")); return; }
      else if(this.state.textField11_isHidden===false && (this.state.textField11_text.length>fieldLength_11) && required_11 && fieldLength_11>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_11+"")); return; }
      else if(this.state.textField12_isHidden===false && (this.state.textField12_text.length>fieldLength_12) && required_12 && fieldLength_12>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_12+"")); return; }
      else if(this.state.textField13_isHidden===false && (this.state.textField13_text.length>fieldLength_13) && required_13 && fieldLength_13>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_13+"")); return; }
      else if(this.state.textField14_isHidden===false && (this.state.textField14_text.length>fieldLength_14) && required_14 && fieldLength_14>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_14+"")); return; }
      else if(this.state.textField15_isHidden===false && (this.state.textField15_text.length>fieldLength_15) && required_15 && fieldLength_15>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_15+"")); return; }
      else if(this.state.textField16_isHidden===false && (this.state.textField16_text.length>fieldLength_16) && required_16 && fieldLength_16>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_16+"")); return; }
      else if(this.state.textField17_isHidden===false && (this.state.textField17_text.length>fieldLength_17) && required_17 && fieldLength_17>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_17+"")); return; }
      else if(this.state.textField18_isHidden===false && (this.state.textField18_text.length>fieldLength_18) && required_18 && fieldLength_18>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_18+"")); return; }
      else if(this.state.textField19_isHidden===false && (this.state.textField19_text.length>fieldLength_19) && required_19 && fieldLength_19>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_19+"")); return; }
      else if(this.state.textField20_isHidden===false && (this.state.textField20_text.length>fieldLength_20) && required_20 && fieldLength_20>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_20+"")); return; }
      else if(this.state.textField21_isHidden===false && (this.state.textField21_text.length>fieldLength_21) && required_21 && fieldLength_21>0){ this.dialog_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength_21+"")); return; }

            if(this.state.picker10_isHidden===false && (this.state.picker10_textFieldLabel1_text === "") && required_10){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField10_plh+"\""); return; }
       else if(this.state.picker11_isHidden===false && (this.state.picker11_textFieldLabel1_text === "") && required_11){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField11_plh+"\""); return; }
       else if(this.state.picker12_isHidden===false && (this.state.picker12_textFieldLabel1_text === "") && required_12){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField12_plh+"\""); return; }
       else if(this.state.picker13_isHidden===false && (this.state.picker13_textFieldLabel1_text === "") && required_13){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField13_plh+"\""); return; }
       else if(this.state.picker14_isHidden===false && (this.state.picker14_textFieldLabel1_text === "") && required_14){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField14_plh+"\""); return; }
       else if(this.state.picker15_isHidden===false && (this.state.picker15_textFieldLabel1_text === "") && required_15){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField15_plh+"\""); return; }
       else if(this.state.picker16_isHidden===false && (this.state.picker16_textFieldLabel1_text === "") && required_16){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField16_plh+"\""); return; }
       else if(this.state.picker17_isHidden===false && (this.state.picker17_textFieldLabel1_text === "") && required_17){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField17_plh+"\""); return; }
       else if(this.state.picker18_isHidden===false && (this.state.picker18_textFieldLabel1_text === "") && required_18){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField18_plh+"\""); return; }
       else if(this.state.picker19_isHidden===false && (this.state.picker19_textFieldLabel1_text === "") && required_19){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField19_plh+"\""); return; }
       else if(this.state.picker20_isHidden===false && (this.state.picker20_textFieldLabel1_text === "") && required_20){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField20_plh+"\""); return; }
       else if(this.state.picker21_isHidden===false && (this.state.picker21_textFieldLabel1_text === "") && required_21){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField21_plh+"\""); return; }

       // if(this.state.textField10_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField10_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField10_plh+"\" "+this.NSInforString("with_latin")); return; }
       // if(this.state.textField11_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField11_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField11_plh+"\" "+this.NSInforString("with_latin")); return; }
       // if(this.state.textField12_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField12_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField12_plh+"\" "+this.NSInforString("with_latin")); return; }
       // if(this.state.textField13_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField13_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField13_plh+"\" "+this.NSInforString("with_latin")); return; }
       // if(this.state.textField14_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField14_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField14_plh+"\" "+this.NSInforString("with_latin")); return; }
       // if(this.state.textField15_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField15_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField15_plh+"\" "+this.NSInforString("with_latin")); return; }
       // if(this.state.textField16_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField16_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField16_plh+"\" "+this.NSInforString("with_latin")); return; }
       // if(this.state.textField17_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField17_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField17_plh+"\" "+this.NSInforString("with_latin")); return; }
       // if(this.state.textField18_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField18_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField18_plh+"\" "+this.NSInforString("with_latin")); return; }
       // if(this.state.textField19_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField19_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField19_plh+"\" "+this.NSInforString("with_latin")); return; }
       // if(this.state.textField20_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField20_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField20_plh+"\" "+this.NSInforString("with_latin")); return; }
       // if(this.state.textField21_isHidden===false && wu_Utilities.offline_validate_latinAlphaNumeric(this.state.textField21_text.replace(/ /g,""))===false){ this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.state.textField21_plh+"\" "+this.NSInforString("with_latin")); return; }
    }

    event.preventDefault();
    this.makeHTTPConn_next_step1();
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_next_step1(){
      let methName = filename+"makeHTTPConn_next_step1 ";
      if(api.print_logs){console.log(methName);}

      if(localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_CreditCard){
        localStorage.setItem("parserObject_cards_res",JSON.stringify([]));
        this.startSpinners();
        setTimeout(function() { //Start the timer
          //------------------
          //wu_cards_cardslist
          //------------------
          wu_CardsService
          .wu_cards_cardslist({})
          .then(res => {
            if(localStorage.getItem("curr_view").trim()!=="TransferOnline2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
            localStorage.setItem("parserObject_cards_res",JSON.stringify(res.custCardTokenList));
            if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
                this.makeHTTPConn_next_d2b();
            }
            else{
                this.makeHTTPConn_next_normal();
            }
          })
          .catch(err => {
            this.stopSpinners();
            console.log(methName+"err="+JSON.stringify(err));
            if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
            else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
          });
        }.bind(this), 500);
      }
      else{
        if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
            this.makeHTTPConn_next_d2b();
        }
        else{
            this.makeHTTPConn_next_normal();
        }
      }
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_next_normal(){
      let methName = filename+"makeHTTPConn_next_normal ";
      if(api.print_logs){console.log(methName);}

      //[Lockers]
      if( this.isLockersActive() ){ return; }
      else                        { this.startLockers(); }

      let rcv_fname = this.state.textField1.trim();
      let rcv_lname = this.state.textField2.trim();
      let TransferOnline1_selCountry      = JSON.parse(localStorage.getItem("TransferOnline1_selCountry"));
      let TransferOnline1_selCurrencyDest = JSON.parse(localStorage.getItem("TransferOnline1_selCurrencyDest"));
      let TransferOnline1_selState        = localStorage.getItem("TransferOnline1_selState")==="" ? null  : JSON.parse(localStorage.getItem("TransferOnline1_selState"));
      let TransferOnline1_selCity         = localStorage.getItem("TransferOnline1_selCity") ==="" ? null  : JSON.parse(localStorage.getItem("TransferOnline1_selCity"));
      //----------------
      //validateoutbound---Prepare Request
      //----------------
      let ctry_wu_id                  = TransferOnline1_selCountry["ctry_wu_id"];
      let state_id                    = TransferOnline1_selState!==null ? TransferOnline1_selState["state_id"] : "";
      let city                        = TransferOnline1_selCity !==null ? TransferOnline1_selCity["city_id"]   : "";
      let snd_curr                    = "EUR";
      let rcv_curr                    = TransferOnline1_selCurrencyDest["curr_iso_id"];
      let principal                   = localStorage.getItem("TransferOnline1_amountToSend");
      let expectedActualPayout        = localStorage.getItem("TransferOnline1_amountToReceive");
      let quest1                      = this.state.textField3.trim();
      let answ1                       = this.state.textField4.trim();
      let afmvat                      = this.state.textField5.trim();

      let requireToPayWithoutValidId1 = "false";
      if(!this.state.view_questCheckbox_isHidden){ requireToPayWithoutValidId1 = this.state.userCheckedTick ? "true" : "false"; }
      else                                       { requireToPayWithoutValidId1 = "false"; }

      let txnchannel                  = (localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_BankTransfer) ? "OnlineMT_Bank" : "OnlineMT_Card";

      let reasonOfPayment             = this.state.picker1_textFieldLabel1_id;
      let sourceOfFund                = this.state.picker1b_textFieldLabel1_id;
      let relationshipWithReceiver    = this.state.picker1c_textFieldLabel1_id;
      let isBehalfThirdParty          = this.state.picker2_textFieldLabel1_id;

      let wantSmsNotification         = "true";
      let pin_code                    = "";

      let promo_validateoutbound      = localStorage.getItem("promo_validateoutbound");
      let promo_sendoutbound          = localStorage.getItem("promo_sendoutbound");

      var parserObject_validateoutbound_req = {};
      parserObject_validateoutbound_req["moneyTransferType"]          = (localStorage.getItem("TransferOnline1_type")===api.TransferOnline1_type_send) ? "0" : "1";
      parserObject_validateoutbound_req["rcv_fname"]                  = rcv_fname;
      parserObject_validateoutbound_req["rcv_lname"]                  = rcv_lname;
      parserObject_validateoutbound_req["ctry_wu_id"]                 = ctry_wu_id;
      parserObject_validateoutbound_req["state_id"]                   = state_id;
      parserObject_validateoutbound_req["city"]                       = city;
      parserObject_validateoutbound_req["snd_curr"]                   = snd_curr;
      parserObject_validateoutbound_req["rcv_curr"]                   = rcv_curr;
      parserObject_validateoutbound_req["principal"]                  = principal;
      parserObject_validateoutbound_req["expectedActualPayout"]       = expectedActualPayout;
      parserObject_validateoutbound_req["quest"]                      = quest1;
      parserObject_validateoutbound_req["answ"]                       = answ1;
      parserObject_validateoutbound_req["afm"]                        = afmvat;
      parserObject_validateoutbound_req["requireToPayWithoutValidId"] = requireToPayWithoutValidId1;
      parserObject_validateoutbound_req["txnchannel"]                 = txnchannel;
      parserObject_validateoutbound_req["reasonOfPayment"]            = reasonOfPayment
      parserObject_validateoutbound_req["srcFunds"]                   = sourceOfFund;
      parserObject_validateoutbound_req["custRelationship"]           = relationshipWithReceiver;
      parserObject_validateoutbound_req["isBehalfThirdParty"]         = isBehalfThirdParty;
      parserObject_validateoutbound_req["promo_code"]                 = promo_validateoutbound;
      localStorage.setItem("parserObject_validateoutbound_req",JSON.stringify(parserObject_validateoutbound_req));

      var parserObject_sendoutbound_req = {};
      parserObject_sendoutbound_req["moneyTransferType"]              = (localStorage.getItem("TransferOnline1_type")===api.TransferOnline1_type_send) ? "0" : "1";
      parserObject_sendoutbound_req["idnum"]                          = "";
      parserObject_sendoutbound_req["birthDate"]                      = "";
      parserObject_sendoutbound_req["rcv_fname"]                      = rcv_fname;
      parserObject_sendoutbound_req["rcv_lname"]                      = rcv_lname;
      parserObject_sendoutbound_req["ctry_wu_id"]                     = ctry_wu_id;
      parserObject_sendoutbound_req["state_id"]                       = state_id;
      parserObject_sendoutbound_req["city"]                           = city;
      parserObject_sendoutbound_req["snd_curr"]                       = snd_curr;
      parserObject_sendoutbound_req["rcv_curr"]                       = rcv_curr;
      parserObject_sendoutbound_req["principal"]                      = principal;
      parserObject_sendoutbound_req["expectedActualPayout"]           = expectedActualPayout;
      parserObject_sendoutbound_req["pin_code"]                       = pin_code;
      parserObject_sendoutbound_req["quest"]                          = quest1;
      parserObject_sendoutbound_req["answ"]                           = answ1;
      parserObject_sendoutbound_req["afm"]                            = afmvat;
      parserObject_sendoutbound_req["requireToPayWithoutValidId"]     = requireToPayWithoutValidId1;
      parserObject_sendoutbound_req["txnchannel"]                     = txnchannel;
      parserObject_sendoutbound_req["reasonOfPayment"]                = reasonOfPayment;
      parserObject_sendoutbound_req["srcFunds"]                       = sourceOfFund;
      parserObject_sendoutbound_req["custRelationship"]               = relationshipWithReceiver;
      parserObject_sendoutbound_req["isBehalfThirdParty"]             = isBehalfThirdParty;
      parserObject_sendoutbound_req["wantSmsNotification"]            = wantSmsNotification;
      parserObject_sendoutbound_req["promo_code"]                     = promo_sendoutbound;
      localStorage.setItem("parserObject_sendoutbound_req",JSON.stringify(parserObject_sendoutbound_req));

      this.startSpinners();
      setTimeout(function() { //Start the timer
        //-------------------
        //wu_validateoutbound
        //-------------------
        wu_TransactionFlow
        .wu_validateoutbound(parserObject_validateoutbound_req)
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="TransferOnline2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          localStorage.setItem("parserObject_sendoutbound_capitalcontrols","");
          localStorage.setItem("parserObject_validateoutbound",            JSON.stringify(res));
          //---------------
          //wu_sendoutbound
          //---------------
          wu_TransactionFlow
          .wu_sendoutbound(parserObject_sendoutbound_req,this.state.countryCode)
          .then(res => {
            if(localStorage.getItem("curr_view").trim()!=="TransferOnline2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
            this.stopLockers();this.stopSpinners();
            localStorage.setItem("parserObject_sendoutbound_capitalcontrols",res.returnText);
            localStorage.setItem("parserObject_sendoutbound",                JSON.stringify(res));
            let centralID = "";
            try { centralID = res["centralID"]; }catch(err){;} if(centralID === null || (typeof centralID ==="undefined")){centralID = "";}
            localStorage.setItem("centralID",centralID);
            if(localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_CreditCard){this.load_localStorage_to_cookies();}

            let parserObject_cards_res = [];
            try{ parserObject_cards_res = JSON.parse(localStorage.getItem("parserObject_cards_res"));}catch(err){console.log(methName+'err='+err);}

            if(localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_CreditCard && parserObject_cards_res.length > 0){
              localStorage.setItem("payWithCardMethod", "payWithCardMethod_Tokenized");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
              //+++++++++++++++
              //Goto Controller
              //+++++++++++++++
              localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
              history.push(wu_Utilities.getNavigationURLs("TransferOnlineCards"));
            }
            else{
              localStorage.setItem("payWithCardMethod", "payWithCardMethod_Normal");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
              //+++++++++++++++
              //Goto Controller
              //+++++++++++++++
              localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
              history.push(wu_Utilities.getNavigationURLs("TransferOnline3"));
            }
          })
          .catch(err => {
            this.stopLockers();this.stopSpinners();
            console.log(methName+"err="+JSON.stringify(err));
            if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
            else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
          });
        })
        .catch(err => {
          this.stopLockers();this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){
            if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));}
            if(err.returnCode===-300){ this.setState({ "picker1b_isHidden":false, "picker1c_isHidden":false}); return; }
            if(err.returnCode===-200){ this.setState({ "textField5_isHidden":false}); return; }
            this.dialog_handleOpen(err.returnText,"NET");
          }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      }.bind(this), 500);
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeHTTPConn_next_d2b(){
      let methName = filename+"makeHTTPConn_next_d2b ";
      if(api.print_logs){console.log(methName);}

      //[Lockers]
      if( this.isLockersActive() ){ return; }
      else                        { this.startLockers(); }

      let rcv_fname = this.state.textField1.trim();
      let rcv_lname = this.state.textField2.trim();
      let TransferOnline1_selCountry      = JSON.parse(localStorage.getItem("TransferOnline1_selCountry"));
      let TransferOnline1_selCurrencyDest = JSON.parse(localStorage.getItem("TransferOnline1_selCurrencyDest"));
      let TransferOnline1_selState        = localStorage.getItem("TransferOnline1_selState")==="" ? null  : JSON.parse(localStorage.getItem("TransferOnline1_selState"));
      let TransferOnline1_selCity         = localStorage.getItem("TransferOnline1_selCity") ==="" ? null  : JSON.parse(localStorage.getItem("TransferOnline1_selCity"));
      //--------------------
      //validateoutbound_d2b---Prepare Request
      //--------------------
      let ctry_wu_id                  = TransferOnline1_selCountry["ctry_wu_id"];
      let state_id                    = TransferOnline1_selState!==null ? TransferOnline1_selState["state_id"] : "";
      let city                        = TransferOnline1_selCity !==null ? TransferOnline1_selCity["city_id"]   : "";
      let snd_curr                    = "EUR";
      let rcv_curr                    = TransferOnline1_selCurrencyDest["curr_iso_id"];
      let principal                   = localStorage.getItem("TransferOnline1_amountToSend");
      let expectedActualPayout        = localStorage.getItem("TransferOnline1_amountToReceive");
      let quest1                      = this.state.textField3.trim();
      let answ1                       = this.state.textField4.trim();
      let afmvat                      = this.state.textField5.trim();

      let requireToPayWithoutValidId1 = "false";
      if(!this.state.view_questCheckbox_isHidden){ requireToPayWithoutValidId1 = this.state.userCheckedTick ? "true" : "false"; }
      else                                       { requireToPayWithoutValidId1 = "false"; }

      let txnchannel                  = (localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_BankTransfer) ? "OnlineMT_Bank" : "OnlineMT_Card";

      let reasonOfPayment             = this.state.picker1_textFieldLabel1_id;
      let sourceOfFund                = this.state.picker1b_textFieldLabel1_id;
      let relationshipWithReceiver    = this.state.picker1c_textFieldLabel1_id;
      let isBehalfThirdParty          = this.state.picker2_textFieldLabel1_id;

      let wantSmsNotification         = "true";
      let pin_code                    = "";

      let promo_validateoutbound      = localStorage.getItem("promo_validateoutbound");
      let promo_sendoutbound          = localStorage.getItem("promo_sendoutbound");

      var parserObject_validateoutbound_d2b_req = {};
      parserObject_validateoutbound_d2b_req["moneyTransferType"]          = (localStorage.getItem("TransferOnline1_type")===api.TransferOnline1_type_send) ? "0" : "1";
      parserObject_validateoutbound_d2b_req["rcv_fname"]                  = rcv_fname;
      parserObject_validateoutbound_d2b_req["rcv_lname"]                  = rcv_lname;
      parserObject_validateoutbound_d2b_req["ctry_wu_id"]                 = ctry_wu_id;
      parserObject_validateoutbound_d2b_req["state_id"]                   = state_id;
      parserObject_validateoutbound_d2b_req["city"]                       = city;
      parserObject_validateoutbound_d2b_req["snd_curr"]                   = snd_curr;
      parserObject_validateoutbound_d2b_req["rcv_curr"]                   = rcv_curr;
      parserObject_validateoutbound_d2b_req["principal"]                  = principal;
      parserObject_validateoutbound_d2b_req["expectedActualPayout"]       = expectedActualPayout;
      parserObject_validateoutbound_d2b_req["quest"]                      = quest1;
      parserObject_validateoutbound_d2b_req["answ"]                       = answ1;
      parserObject_validateoutbound_d2b_req["afm"]                        = afmvat;
      parserObject_validateoutbound_d2b_req["requireToPayWithoutValidId"] = requireToPayWithoutValidId1;
      parserObject_validateoutbound_d2b_req["txnchannel"]                 = txnchannel;
      parserObject_validateoutbound_d2b_req["reasonOfPayment"]            = reasonOfPayment
      parserObject_validateoutbound_d2b_req["srcFunds"]                   = sourceOfFund;
      parserObject_validateoutbound_d2b_req["custRelationship"]           = relationshipWithReceiver;
      parserObject_validateoutbound_d2b_req["isBehalfThirdParty"]         = isBehalfThirdParty;
      parserObject_validateoutbound_d2b_req["D2BField_xml"]               = this.get_D2BFields_xml();
      parserObject_validateoutbound_d2b_req["promo_code"]                 = promo_validateoutbound;
      localStorage.setItem("parserObject_validateoutbound_d2b_req",JSON.stringify(parserObject_validateoutbound_d2b_req));

      var parserObject_sendoutbound_d2b_req = {};
      parserObject_sendoutbound_d2b_req["moneyTransferType"]              = (localStorage.getItem("TransferOnline1_type")===api.TransferOnline1_type_send) ? "0" : "1";
      parserObject_sendoutbound_d2b_req["idnum"]                          = "";
      parserObject_sendoutbound_d2b_req["rcv_fname"]                      = rcv_fname;
      parserObject_sendoutbound_d2b_req["rcv_lname"]                      = rcv_lname;
      parserObject_sendoutbound_d2b_req["ctry_wu_id"]                     = ctry_wu_id;
      parserObject_sendoutbound_d2b_req["state_id"]                       = state_id;
      parserObject_sendoutbound_d2b_req["city"]                           = city;
      parserObject_sendoutbound_d2b_req["snd_curr"]                       = snd_curr;
      parserObject_sendoutbound_d2b_req["rcv_curr"]                       = rcv_curr;
      parserObject_sendoutbound_d2b_req["principal"]                      = principal;
      parserObject_sendoutbound_d2b_req["expectedActualPayout"]           = expectedActualPayout;
      parserObject_sendoutbound_d2b_req["pin_code"]                       = pin_code;
      parserObject_sendoutbound_d2b_req["quest"]                          = quest1;
      parserObject_sendoutbound_d2b_req["answ"]                           = answ1;
      parserObject_sendoutbound_d2b_req["afm"]                            = afmvat;
      parserObject_sendoutbound_d2b_req["requireToPayWithoutValidId"]     = requireToPayWithoutValidId1;
      parserObject_sendoutbound_d2b_req["txnchannel"]                     = txnchannel;
      parserObject_sendoutbound_d2b_req["reasonOfPayment"]                = reasonOfPayment;
      parserObject_sendoutbound_d2b_req["srcFunds"]                       = sourceOfFund;
      parserObject_sendoutbound_d2b_req["custRelationship"]               = relationshipWithReceiver;
      parserObject_sendoutbound_d2b_req["wantSmsNotification"]            = wantSmsNotification;
      parserObject_sendoutbound_d2b_req["isBehalfThirdParty"]             = isBehalfThirdParty;
      parserObject_sendoutbound_d2b_req["D2BField_xml"]                   = this.get_D2BFields_xml();
      parserObject_sendoutbound_d2b_req["promo_code"]                     = promo_sendoutbound;
      localStorage.setItem("parserObject_sendoutbound_d2b_req",JSON.stringify(parserObject_sendoutbound_d2b_req));

      this.startSpinners();
      setTimeout(function() { //Start the timer
        //-----------------------
        //wu_validateoutbound_d2b
        //-----------------------
        wu_TransactionFlow
        .wu_validateoutbound_d2b(parserObject_validateoutbound_d2b_req)
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="TransferOnline2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          localStorage.setItem("parserObject_sendoutbound_d2b_capitalcontrols","");
          localStorage.setItem("parserObject_validateoutbound_d2b",            JSON.stringify(res));
          //-------------------
          //wu_sendoutbound_d2b
          //-------------------
          wu_TransactionFlow
          .wu_sendoutbound_d2b(parserObject_sendoutbound_d2b_req,this.state.countryCode)
          .then(res => {
            if(localStorage.getItem("curr_view").trim()!=="TransferOnline2"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
            this.stopLockers();this.stopSpinners();
            localStorage.setItem("parserObject_sendoutbound_d2b_capitalcontrols",res.returnText);
            localStorage.setItem("parserObject_sendoutbound_d2b",                JSON.stringify(res));
            let centralID = "";
            try { centralID = res["centralID"]; }catch(err){;} if(centralID === null || (typeof centralID ==="undefined")){centralID = "";}
            localStorage.setItem("centralID",centralID);
            if(localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_CreditCard){this.load_localStorage_to_cookies();}

            let parserObject_cards_res = {};
            try{ parserObject_cards_res = JSON.parse(localStorage.getItem("parserObject_cards_res"));}catch(err){console.log(methName+'err='+err);}

            if(localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_CreditCard && parserObject_cards_res.length > 0){
              localStorage.setItem("payWithCardMethod", "payWithCardMethod_Tokenized");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
              //+++++++++++++++
              //Goto Controller
              //+++++++++++++++
              localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
              history.push(wu_Utilities.getNavigationURLs("TransferOnlineCards"));
            }
            else{
              localStorage.setItem("payWithCardMethod", "payWithCardMethod_Normal");//payWithCardMethod_Normal,payWithCardMethod_Tokenized
              //+++++++++++++++
              //Goto Controller
              //+++++++++++++++
              localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
              history.push(wu_Utilities.getNavigationURLs("TransferOnline3"));
            }
          })
          .catch(err => {
            this.stopLockers();this.stopSpinners();
            console.log(methName+"err="+JSON.stringify(err));
            if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
            else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
          });
        })
        .catch(err => {
          this.stopLockers();this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){
            if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));}
            if(err.returnCode===-300){ this.setState({ "picker1b_isHidden":false, "picker1c_isHidden":false}); return; }
            if(err.returnCode===-200){ this.setState({ "textField5_isHidden":false}); return; }
            this.dialog_handleOpen(err.returnText,"NET");
          }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  get_D2BFields_xml(){
    let methName = filename+"get_D2BFields_xml ";
    if(api.print_logs){console.log(methName);}

    let parserObject_getd2bfields_JSON = [];
    let xml = "";
    let d2bCnt = this.state.parserObject_getd2bfields.length;

    if(d2bCnt>=1){
        let textField10text = this.state.textField10_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField10text,0);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField10text,0));
    }
    if(d2bCnt>=2){
        let textField11text = this.state.textField11_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField11text,1);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField11text,1));
    }
    if(d2bCnt>=3){
        let textField12text = this.state.textField12_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField12text,2);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField12text,2));
    }
    if(d2bCnt>=4){
        let textField13text = this.state.textField13_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField13text,3);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField13text,3));
    }
    if(d2bCnt>=5){
        let textField14text = this.state.textField14_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField14text,4);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField14text,4));
    }
    if(d2bCnt>=6){
        let textField15text = this.state.textField15_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField15text,5);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField15text,5));
    }
    if(d2bCnt>=7){
        let textField16text = this.state.textField16_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField16text,6);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField16text,6));
    }
    if(d2bCnt>=8){
        let textField17text = this.state.textField17_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField17text,7);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField17text,7));
    }
    if(d2bCnt>=9){
        let textField18text = this.state.textField18_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField18text,8);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField18text,8));
    }
    if(d2bCnt>=10){
        let textField19text = this.state.textField19_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField19text,9);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField19text,9));
    }
    if(d2bCnt>=11){
        let textField20text = this.state.textField20_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField20text,10);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField20text,10));
    }
    if(d2bCnt>=12){
        let textField21text = this.state.textField21_text.trim();
        let xmlItem         = this.get_D2BField_xml_value(textField21text,11);
        xml                 = xml+xmlItem;
        parserObject_getd2bfields_JSON.push(this.get_D2BField_json_value(textField21text,11));
    }
    localStorage.setItem("parserObject_getd2bfields_JSON", JSON.stringify(parserObject_getd2bfields_JSON));
    //console.log("parserObject_getd2bfields_JSON="+JSON.stringify(parserObject_getd2bfields_JSON));

    return xml;
  }
  //----------------------------------------------------------------------------------------------------
  get_D2BField_xml_value(textFieldNN,index){
    let methName = filename+"get_D2BField_xml_value ";
    if(api.print_logs){console.log(methName);}

    let dbFieldId         = "";
    let fieldId           = "";
    let fieldLength       = "";
    let fieldName         = "";
    let fieldRequiredText = "";
    let fieldType         = "";
    let required          = "";
    try{ dbFieldId         = this.state.parserObject_getd2bfields[index]["dbFieldId"];         }catch (err){ ; }
    try{ fieldId           = this.state.parserObject_getd2bfields[index]["fieldId"];           }catch (err){ ; }
    try{ fieldLength       = this.state.parserObject_getd2bfields[index]["fieldLength"];       }catch (err){ ; }
    try{ fieldName         = this.state.parserObject_getd2bfields[index]["fieldName"];         }catch (err){ ; }
    try{ fieldRequiredText = this.state.parserObject_getd2bfields[index]["fieldRequiredText"]; }catch (err){ ; }
    try{ fieldType         = this.state.parserObject_getd2bfields[index]["fieldType"];         }catch (err){ ; }
    try{ required          = this.state.parserObject_getd2bfields[index]["required"];          }catch (err){ ; }

    if(fieldType === "COMBO" || fieldType === "COMBO2"){
        if(index===0) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker10_selIndex); }
        if(index===1) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker11_selIndex); }
        if(index===2) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker12_selIndex); }
        if(index===3) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker13_selIndex); }
        if(index===4) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker14_selIndex); }
        if(index===5) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker15_selIndex); }
        if(index===6) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker16_selIndex); }
        if(index===7) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker17_selIndex); }
        if(index===8) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker18_selIndex); }
        if(index===9) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker19_selIndex); }
        if(index===10){ textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker20_selIndex); }
        if(index===11){ textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker21_selIndex); }
    }
    let xmlItem =  "<D2BField>"+
                   "<dbFieldId>"+dbFieldId+"</dbFieldId>"+
                   "<fieldId>"+fieldId+"</fieldId>"+
                   "<fieldLength>"+fieldLength+"</fieldLength>"+
                   "<fieldName>"+fieldName+"</fieldName>"+
                   "<fieldRequiredText>"+fieldRequiredText+"</fieldRequiredText>"+
                   "<fieldType>"+fieldType+"</fieldType>"+
                   "<required>"+required+"</required>"+
                   "<value>"+textFieldNN+"</value>"+
                   "</D2BField>";
    return xmlItem;
  }
  //----------------------------------------------------------------------------------------------------
  get_D2BField_json_value(textFieldNN,index){
    let methName = filename+"get_D2BField_json_value ";
    if(api.print_logs){console.log(methName);}

    let dbFieldId         = "";
    let fieldId           = "";
    let fieldLength       = "";
    let fieldName         = "";
    let fieldRequiredText = "";
    let fieldType         = "";
    let required          = "";
    try{ dbFieldId         = this.state.parserObject_getd2bfields[index]["dbFieldId"];         }catch (err){ ; }
    try{ fieldId           = this.state.parserObject_getd2bfields[index]["fieldId"];           }catch (err){ ; }
    try{ fieldLength       = this.state.parserObject_getd2bfields[index]["fieldLength"];       }catch (err){ ; }
    try{ fieldName         = this.state.parserObject_getd2bfields[index]["fieldName"];         }catch (err){ ; }
    try{ fieldRequiredText = this.state.parserObject_getd2bfields[index]["fieldRequiredText"]; }catch (err){ ; }
    try{ fieldType         = this.state.parserObject_getd2bfields[index]["fieldType"];         }catch (err){ ; }
    try{ required          = this.state.parserObject_getd2bfields[index]["required"];          }catch (err){ ; }

    if(fieldType === "COMBO" || fieldType === "COMBO2"){
        // if(index===0) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker10_selIndex); }
        // if(index===1) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker11_selIndex); }
        // if(index===2) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker12_selIndex); }
        // if(index===3) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker13_selIndex); }
        // if(index===4) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker14_selIndex); }
        // if(index===5) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker15_selIndex); }
        // if(index===6) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker16_selIndex); }
        // if(index===7) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker17_selIndex); }
        // if(index===8) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker18_selIndex); }
        // if(index===9) { textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker19_selIndex); }
        // if(index===10){ textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker20_selIndex); }
        // if(index===11){ textFieldNN = this.get_fieldCode_pickerIndex(index,this.state.picker21_selIndex); }

        if(index===0) { textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker10_selIndex); }
        if(index===1) { textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker11_selIndex); }
        if(index===2) { textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker12_selIndex); }
        if(index===3) { textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker13_selIndex); }
        if(index===4) { textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker14_selIndex); }
        if(index===5) { textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker15_selIndex); }
        if(index===6) { textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker16_selIndex); }
        if(index===7) { textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker17_selIndex); }
        if(index===8) { textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker18_selIndex); }
        if(index===9) { textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker19_selIndex); }
        if(index===10){ textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker20_selIndex); }
        if(index===11){ textFieldNN = this.get_fieldName_pickerIndex(index,this.state.picker21_selIndex); }
    }

    let jsonItem = {};
    jsonItem["dbFieldId"]         = dbFieldId;
    jsonItem["fieldId"]           = fieldId;
    jsonItem["fieldLength"]       = fieldLength;
    jsonItem["fieldName"]         = fieldName;
    jsonItem["fieldRequiredText"] = fieldRequiredText;
    jsonItem["fieldType"]         = fieldType;
    jsonItem["required"]          = required;
    jsonItem["value"]             = textFieldNN;

    return jsonItem;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  get_fieldCode_pickerIndex(pickerIndex,rowIndex){

      let comboValues = [];
      //try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"]; }catch (err) { ; }

      let listType = null;
      try{ listType = this.state.parserObject_getd2bfields[pickerIndex]["listType"]; }catch (err) { listType = null; }
      if(listType===null){ try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
      if(listType===1)   { try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
      if(listType===2)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level1_tIndex_value); }catch (err) { comboValues = []; } }
      if(listType===3)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level2_tIndex_value); }catch (err) { comboValues = []; } }
      if(listType===4)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level3_tIndex_value); }catch (err) { comboValues = []; } }
      if(listType===5)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level4_tIndex_value); }catch (err) { comboValues = []; } }

      let fieldCode = "";
      try{ fieldCode = comboValues[rowIndex]["fieldCode"]; }catch (err) { ; }
      if(fieldCode === null){fieldCode = ""; }
      console.log("get_fieldCode_pickerIndex pickerIndex="+pickerIndex+",rowIndex="+rowIndex+",fieldCode="+fieldCode);
      return fieldCode;
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  get_fieldName_pickerIndex(pickerIndex,rowIndex){

      let comboValues = [];
      //try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"]; }catch (err) { ; }

      let listType = null;
      try{ listType = this.state.parserObject_getd2bfields[pickerIndex]["listType"]; }catch (err) { listType = null; }
      if(listType===null){ try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
      if(listType===1)   { try{ comboValues = this.state.parserObject_getd2bfields[pickerIndex]["comboValues"];                       }catch (err) { comboValues = []; } }
      if(listType===2)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level1_tIndex_value); }catch (err) { comboValues = []; } }
      if(listType===3)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level2_tIndex_value); }catch (err) { comboValues = []; } }
      if(listType===4)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level3_tIndex_value); }catch (err) { comboValues = []; } }
      if(listType===5)   { try{ comboValues = this.get_combo_comboValues_based_on_tIndex(pickerIndex,this.state.level4_tIndex_value); }catch (err) { comboValues = []; } }

      let fieldValue = "";
      try{ fieldValue = comboValues[rowIndex]["fieldValue"]; }catch (err) { ; }
      if(fieldValue === null){fieldValue = ""; }
      console.log("get_fieldCode_pickerIndex pickerIndex="+pickerIndex+",rowIndex="+rowIndex+",fieldValue="+fieldValue);
      return fieldValue;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+event.target.value);}

    // if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
    //   this.setState({"textField0":eventTMP.trim(),});
    // }
    if(stateVar==="textField1"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField1"          : eventTMP,
        "textField1_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField1_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstName.size")); this.setState({"textField1_hasError":true}); return; }
      if(eventTMP.trim().length + this.state.textField2.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"textField1_hasError":true, "textField2_hasError":true}); return; }
      else                                                                 { this.setState({"textField1_hasError":false, "textField2_hasError":false}); }
    }
    else if(stateVar==="textField2"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField2"          : eventTMP,
        "textField2_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField2_hasError":true}); return; }
      if(eventTMP.length > 36){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstName.size")); this.setState({"textField2_hasError":true}); return; }
      if(this.state.textField1.trim().length + eventTMP.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.firstlastName.size")); this.setState({"textField1_hasError":true, "textField2_hasError":true}); return; }
      else                                                                 { this.setState({"textField1_hasError":false, "textField2_hasError":false}); }
    }
    else if(stateVar==="textField3"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField3"          : eventTMP,
        "textField3_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField3_hasError":true}); return; }
      if(eventTMP.trim().length + this.state.textField4.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.securityQuestionAnswer.size")); this.setState({"textField3_hasError":true, "textField4_hasError":true}); return; }
      else                                                                 { this.setState({"textField3_hasError":false, "textField4_hasError":false}); }
    }
    else if(stateVar==="textField4"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField4"          : eventTMP,
        "textField4_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField4_hasError":true}); return; }
      if(this.state.textField3.trim().length + eventTMP.trim().length > 39){ this.Snackbar_textField_handleOpen(this.NSInforString("common.securityQuestionAnswer.size")); this.setState({"textField3_hasError":true, "textField4_hasError":true}); return; }
      else                                                                 { this.setState({"textField3_hasError":false, "textField4_hasError":false}); }
    }
    else if(stateVar==="textField5"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField5"          : eventTMP,
        "textField5_hasError" : (eventTMP.trim() === "") ? true : false,
      });
    }
    else if(stateVar==="textField10_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[0]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[0]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 10",this.state.textField10_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField10_hasError" : (eventTMP.trim() === "") ? true : false, "textField10_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField10_hasError" : (eventTMP.trim() === "") ? true : false, "textField10_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField10_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField10_hasError":true}); return; }
    }
    else if(stateVar==="textField11_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[1]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[0]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 11",this.state.textField11_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField11_hasError" : (eventTMP.trim() === "") ? true : false, "textField11_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField11_hasError" : (eventTMP.trim() === "") ? true : false, "textField11_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField11_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField11_hasError":true}); return; }
    }
    else if(stateVar==="textField12_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[2]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[2]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 12",this.state.textField12_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField12_hasError" : (eventTMP.trim() === "") ? true : false, "textField12_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField12_hasError" : (eventTMP.trim() === "") ? true : false, "textField12_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField12_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField12_hasError":true}); return; }
    }
    else if(stateVar==="textField13_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[3]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[3]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 13",this.state.textField13_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField13_hasError" : (eventTMP.trim() === "") ? true : false, "textField13_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField13_hasError" : (eventTMP.trim() === "") ? true : false, "textField13_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField13_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField13_hasError":true}); return; }
    }
    else if(stateVar==="textField14_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[4]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[4]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 14",this.state.textField14_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField14_hasError" : (eventTMP.trim() === "") ? true : false, "textField14_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField14_hasError" : (eventTMP.trim() === "") ? true : false, "textField14_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField14_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField14_hasError":true}); return; }
    }
    else if(stateVar==="textField15_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[5]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[5]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 15",this.state.textField15_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField15_hasError" : (eventTMP.trim() === "") ? true : false, "textField15_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField15_hasError" : (eventTMP.trim() === "") ? true : false, "textField15_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField15_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField15_hasError":true}); return; }
    }
    else if(stateVar==="textField16_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[6]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[6]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 16",this.state.textField16_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField16_hasError" : (eventTMP.trim() === "") ? true : false, "textField16_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField16_hasError" : (eventTMP.trim() === "") ? true : false, "textField16_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField16_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField16_hasError":true}); return; }
    }
    else if(stateVar==="textField17_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[7]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[7]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 17",this.state.textField17_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField17_hasError" : (eventTMP.trim() === "") ? true : false, "textField17_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField17_hasError" : (eventTMP.trim() === "") ? true : false, "textField17_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField17_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField17_hasError":true}); return; }
    }
    else if(stateVar==="textField18_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[8]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[8]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 18",this.state.textField18_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField18_hasError" : (eventTMP.trim() === "") ? true : false, "textField18_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField18_hasError" : (eventTMP.trim() === "") ? true : false, "textField18_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField18_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField18_hasError":true}); return; }
    }
    else if(stateVar==="textField19_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[9]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[9]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 19",this.state.textField19_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField19_hasError" : (eventTMP.trim() === "") ? true : false, "textField19_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField19_hasError" : (eventTMP.trim() === "") ? true : false, "textField19_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField19_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField19_hasError":true}); return; }
    }
    else if(stateVar==="textField20_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[10]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[10]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 20",this.state.textField20_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField20_hasError" : (eventTMP.trim() === "") ? true : false, "textField20_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField20_hasError" : (eventTMP.trim() === "") ? true : false, "textField20_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField20_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField20_hasError":true}); return; }
    }
    else if(stateVar==="textField21_text"){
      let fieldType = ""; try{ fieldType = this.state.parserObject_getd2bfields[11]["fieldType"]; }catch (err){ ; }
    //let fieldLength = 0; try{ fieldLength = parseInt(this.state.parserObject_getd2bfields[11]["fieldLength"]); }catch (err){ fieldLength = 0; }
      let fieldLength = 0; try{ fieldLength = this.find_fieldLength_fromFieldName("change 21",this.state.textField21_plh,this.state.parserObject_getd2bfields) }catch (err){ fieldLength = 0; }
      if(fieldType==="UPRSTRING"){ this.setState({ "textField21_hasError" : (eventTMP.trim() === "") ? true : false, "textField21_text":(event.target.value+"").toUpperCase() }); }
      else                       { this.setState({ "textField21_hasError" : (eventTMP.trim() === "") ? true : false, "textField21_text":event.target.value+"" });                 }
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinAlphaNumeric(eventTMP.replace(/ /g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField21_hasError":true}); return; }
      if(eventTMP.trim().length>fieldLength && fieldLength>0){ this.Snackbar_textField_handleOpen(this.NSInforString("common.generic.size").replace(/NN/g,fieldLength+"")); this.setState({"textField21_hasError":true}); return; }
    }
    else{
      this.setState({ [stateVar] : event.target.value });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email")                            { return wu_Utilities.wu_verifyEmail(val); }
    if(key==="MTCN")                             { return wu_Utilities.wu_verifyMTCN(val);  }
    if(key==="firstName")                        { if(val){val=val.replace(/ /g,"")}; return wu_Utilities.offline_validate_firstName(val); }
    if(key==="lastName")                         { if(val){val=val.replace(/ /g,"")}; return wu_Utilities.offline_validate_lastName(val);  }
    if(key==="securityQuestion")                 { return wu_Utilities.offline_validate_securityQuestion(val);  }
    if(key==="securityAnswer")                   { return wu_Utilities.offline_validate_securityAnswer(val);  }

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  load_localStorage_to_cookies(){
    let methName = filename+"load_localStorage_to_cookies ";
    if(api.print_logs){console.log(methName);}

    try{
      try{ Cookies.set('platform',                     "webapp-react",                                         {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('lang',                          localStorage.getItem("lang"),                          {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('isLoggedIn',                    "true",                                                {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('accessToken',                   localStorage.getItem("accessToken"),                   {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('refreshToken',                  localStorage.getItem("refreshToken"),                  {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('tokenID',                       localStorage.getItem("tokenID"),                       {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('centralID',                     localStorage.getItem("centralID"),                     {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('TransferOnline1_PaymentMethod', localStorage.getItem("TransferOnline1_PaymentMethod"), {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('TransferOnline1_TransferMethod',localStorage.getItem("TransferOnline1_TransferMethod"),{secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

      try{ Cookies.set('TransferOnline1_selCountry_ctry_wu_id',localStorage.getItem("TransferOnline1_selCountry_ctry_wu_id"),{secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      // try{ Cookies.set('TransferOnline1_selCountry_ctry_wu_id',localStorage.getItem("TransferOnline1_selCountry_ctry_wu_id")); }catch(err){console.log(methName+"err="+err);}

      // parserObject_validateoutbound_d2b
      // parserObject_validateoutbound
      // --gross
      // --normalCharges
      // --expectedActualPayout
      //
      // parserObject_sendoutbound_d2b_req
      // parserObject_sendoutbound_req
      // --rcv_curr
      // --principal
      // --rcv_fname
      // --rcv_lname

      let gross                = 0.0; //float
      let normalCharges        = 0.0; //float
      let expectedActualPayout = 0.0; //float
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_validateoutbound_d2b = {};
          try { parserObject_validateoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_validateoutbound_d2b")); }catch(err){;}
          try {gross                = parserObject_validateoutbound_d2b["gross"];                 }catch(err){;} if(gross                === null || (typeof gross==="undefined")){ gross = 0.0;}
          try {normalCharges        = parserObject_validateoutbound_d2b["normalCharges"];         }catch(err){;} if(normalCharges        === null || (typeof normalCharges==="undefined")){ normalCharges = 0.0;}
          try {expectedActualPayout = parserObject_validateoutbound_d2b["expectedActualPayout"];  }catch(err){;} if(expectedActualPayout === null || (typeof expectedActualPayout==="undefined")){ expectedActualPayout = 0.0;}
      }
      else{
          let parserObject_validateoutbound = {};
          try { parserObject_validateoutbound = JSON.parse(localStorage.getItem("parserObject_validateoutbound")); }catch(err){;}
          try {gross                = parserObject_validateoutbound["gross"];                 }catch(err){;} if(gross                === null || (typeof gross==="undefined")){ gross = 0.0;}
          try {normalCharges        = parserObject_validateoutbound["normalCharges"];         }catch(err){;} if(normalCharges        === null || (typeof normalCharges==="undefined")){ normalCharges = 0.0;}
          try {expectedActualPayout = parserObject_validateoutbound["expectedActualPayout"];  }catch(err){;} if(expectedActualPayout === null || (typeof expectedActualPayout==="undefined")){ expectedActualPayout = 0.0;}
      }
      try{ Cookies.set('gross',                         gross.toFixed(2),                                      {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('normalCharges',                 normalCharges.toFixed(2),                              {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('expectedActualPayout',          expectedActualPayout.toFixed(2),                       {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      // try{ Cookies.set('gross',                         gross.toFixed(2));               }catch(err){console.log(methName+"err="+err);}
      // try{ Cookies.set('normalCharges',                 normalCharges.toFixed(2);        }catch(err){console.log(methName+"err="+err);}
      // try{ Cookies.set('expectedActualPayout',          expectedActualPayout.toFixed(2); }catch(err){console.log(methName+"err="+err);}

      let rcv_curr             = "";
      let principal            = 0.0;
      let rcv_fname            = "";
      let rcv_lname            = "";
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_sendoutbound_d2b_req = {};
          try { parserObject_sendoutbound_d2b_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b_req")); }catch(err){;}
          try {rcv_curr             = parserObject_sendoutbound_d2b_req["rcv_curr"];             }catch(err){;} if(rcv_curr === null || (typeof rcv_curr==="undefined")){rcv_curr = "";}
          try {principal            = parserObject_sendoutbound_d2b_req["principal"];            }catch(err){;}
          try {rcv_fname            = parserObject_sendoutbound_d2b_req["rcv_fname"];            }catch(err){;} if(rcv_fname === null || (typeof rcv_fname==="undefined")){rcv_fname = "";}
          try {rcv_lname            = parserObject_sendoutbound_d2b_req["rcv_lname"];            }catch(err){;} if(rcv_lname === null || (typeof rcv_lname==="undefined")){rcv_lname = "";}
      }
      else{
          let parserObject_sendoutbound_req = {};
          try { parserObject_sendoutbound_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_req")); }catch(err){;}
          try {rcv_curr             = parserObject_sendoutbound_req["rcv_curr"];             }catch(err){;} if(rcv_curr === null || (typeof rcv_curr==="undefined")){rcv_curr = "";}
          try {principal            = parserObject_sendoutbound_req["principal"];            }catch(err){;}
          try {rcv_fname            = parserObject_sendoutbound_req["rcv_fname"];            }catch(err){;} if(rcv_fname === null || (typeof rcv_fname==="undefined")){rcv_fname = "";}
          try {rcv_lname            = parserObject_sendoutbound_req["rcv_lname"];            }catch(err){;} if(rcv_lname === null || (typeof rcv_lname==="undefined")){rcv_lname = "";}
      }
      try{ Cookies.set('rcv_curr',                      rcv_curr,                                              {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('principal',                     principal.toFixed(2),                                  {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('rcv_fname',                     rcv_fname,                                             {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.set('rcv_lname',                     rcv_lname,                                             {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      // try{ Cookies.set('rcv_curr',                      rcv_curr            );            }catch(err){console.log(methName+"err="+err);}
      // try{ Cookies.set('principal',                     principal.toFixed(2));            }catch(err){console.log(methName+"err="+err);}
      // try{ Cookies.set('rcv_fname',                     rcv_fname           );            }catch(err){console.log(methName+"err="+err);}
      // try{ Cookies.set('rcv_lname',                     rcv_lname           );            }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    console.log("goBack "+localStorage.getItem("prev_view").trim());
    if(localStorage.getItem("prev_view").trim()==="TransferOnlineLogin" || localStorage.getItem("prev_view").trim()==="RegisterLight3" || localStorage.getItem("prev_view").trim()==="TransferOnlineCards"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("TransferOnline1"));
    }
    else{
      //history.go(-1);
      history.goBack();
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  dialogYN_handleOpen(dialogYN_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialogYN_isOpen" : true,
          "dialogYN_msg"    : dialogYN_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialogYN_isOpen" : true,
      "dialogYN_msg"    : dialogYN_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialogYN_handleClose_Y(){
    let methName = filename+"dialogYN_handleClose_Y ";
    if(api.print_logs){console.log(methName);}

    this.setState({ "dialogYN_isOpen": false });
    if(api.new_registration_enabled){
      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      let customerLevel = wu_Utilities.textDecisions_customerLevel(api.print_logs,parserObject_validatecustomer);
      if(api.print_logs){console.log(methName+"customerLevel="+customerLevel);}
      if(customerLevel==="LIGHT"){ try {localStorage.setItem("newRegistrationFlow","newCustomer");   }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
      if(customerLevel==="BP")   { try {localStorage.setItem("newRegistrationFlow","upgradeAccount");}catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }
      if(customerLevel==="FULL") { try {localStorage.setItem("newRegistrationFlow","changeId");      }catch(err){;} history.push(wu_Utilities.getNavigationURLs("RegisterLightInfo")); return; }//SOS XXX ???
    }
  }
  dialogYN_handleClose_N(){
    this.setState({ "dialogYN_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( TransferOnline2_continue_locked===true ){ return true;  }
    else                                        { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    TransferOnline2_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    TransferOnline2_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------IE11----------------------------------------------
  //----------------------------------------------------------------------------------------------------
  IE11_not_loading_state_workaround(){
    let ua   = window.navigator.userAgent;
    let msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!ua.match(/Trident.*rv\:11\./)){
      let stateObj = {};
      let hasAField = false;
      if(this.state.textField1===""){ stateObj.textField1 = Cookies.get('rcv_fname'); hasAField = true; }
      if(this.state.textField2===""){ stateObj.textField2 = Cookies.get('rcv_lname'); hasAField = true; }
      if(hasAField===true){this.setState(stateObj);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------IOS12---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  isWebAppIOS12x() {
    let methName = filename+"isWebAppIOS12x ";
    try{
      let ua = window.navigator.userAgent;
      if (/iP(hone|od|ad)/.test(ua)) {
        var v = (ua).match(/OS (\d+)_(\d+)_?(\d+)?/);
        //return parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10);
        console.log(methName+"iOS version="+parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10));
        if(parseInt(v[1], 10)===12){
          return true;
        }
      }
    }catch(err){
      console.log(methName+"err="+err);
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
}
TransferOnline2.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(TransferOnline2Style)(TransferOnline2)
);
